import { jsx } from 'react/jsx-runtime';
import { Illustration } from '@gemini/core';

const EmptyDefaultBackgroundBanner = ({ size = "280", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "banner/EmptyDefaultBackground_280.webp",
        responsiveSrc: [
            "banner/EmptyDefaultBackground_280.webp 1x",
            "banner/EmptyDefaultBackground_560.webp 2x",
            "banner/EmptyDefaultBackground_840.webp 3x"
        ],
        size: size
    });
};

const ErrorFavoritesUnavailableBanner = ({ size = "280", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "banner/ErrorFavoritesUnavailable_280.webp",
        responsiveSrc: [
            "banner/ErrorFavoritesUnavailable_280.webp 1x",
            "banner/ErrorFavoritesUnavailable_560.webp 2x",
            "banner/ErrorFavoritesUnavailable_840.webp 3x"
        ],
        size: size
    });
};

const ErrorListingDeletedDisableBanner = ({ size = "280", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "banner/ErrorListingDeletedDisable_280.webp",
        responsiveSrc: [
            "banner/ErrorListingDeletedDisable_280.webp 1x",
            "banner/ErrorListingDeletedDisable_560.webp 2x",
            "banner/ErrorListingDeletedDisable_840.webp 3x"
        ],
        size: size
    });
};

const OnboardingAppBanner = ({ size = "280", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "banner/OnboardingApp_280.webp",
        responsiveSrc: [
            "banner/OnboardingApp_280.webp 1x",
            "banner/OnboardingApp_560.webp 2x",
            "banner/OnboardingApp_840.webp 3x"
        ],
        size: size
    });
};

const OnboardingLandingPageBanner = ({ size = "280", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "banner/OnboardingLandingPage_280.webp",
        responsiveSrc: [
            "banner/OnboardingLandingPage_280.webp 1x",
            "banner/OnboardingLandingPage_560.webp 2x",
            "banner/OnboardingLandingPage_840.webp 3x"
        ],
        size: size
    });
};

const PropertyCardApartmentBanner = ({ size = "280", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "banner/PropertyCardApartment_280.webp",
        responsiveSrc: [
            "banner/PropertyCardApartment_280.webp 1x",
            "banner/PropertyCardApartment_560.webp 2x",
            "banner/PropertyCardApartment_840.webp 3x"
        ],
        size: size
    });
};

const PropertyCardHouseBanner = ({ size = "280", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "banner/PropertyCardHouse_280.webp",
        responsiveSrc: [
            "banner/PropertyCardHouse_280.webp 1x",
            "banner/PropertyCardHouse_560.webp 2x",
            "banner/PropertyCardHouse_840.webp 3x"
        ],
        size: size
    });
};

const PropertyCardParkingBanner = ({ size = "280", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "banner/PropertyCardParking_280.webp",
        responsiveSrc: [
            "banner/PropertyCardParking_280.webp 1x",
            "banner/PropertyCardParking_560.webp 2x",
            "banner/PropertyCardParking_840.webp 3x"
        ],
        size: size
    });
};

const TeaserMortgageHpBanner = ({ size = "280", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "banner/TeaserMortgageHp_280.webp",
        responsiveSrc: [
            "banner/TeaserMortgageHp_280.webp 1x",
            "banner/TeaserMortgageHp_560.webp 2x",
            "banner/TeaserMortgageHp_840.webp 3x"
        ],
        size: size
    });
};

const TeaserMovingHpBanner = ({ size = "280", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "banner/TeaserMovingHp_280.webp",
        responsiveSrc: [
            "banner/TeaserMovingHp_280.webp 1x",
            "banner/TeaserMovingHp_560.webp 2x",
            "banner/TeaserMovingHp_840.webp 3x"
        ],
        size: size
    });
};

const TeaserRenovationHpBanner = ({ size = "280", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "banner/TeaserRenovationHp_280.webp",
        responsiveSrc: [
            "banner/TeaserRenovationHp_280.webp 1x",
            "banner/TeaserRenovationHp_560.webp 2x",
            "banner/TeaserRenovationHp_840.webp 3x"
        ],
        size: size
    });
};

const EmptyAgencyReviewsNoLoadingHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyAgencyReviewsNoLoading_144.webp",
        responsiveSrc: [
            "hero/EmptyAgencyReviewsNoLoading_144.webp 1x",
            "hero/EmptyAgencyReviewsNoLoading_288.webp 2x",
            "hero/EmptyAgencyReviewsNoLoading_432.webp 3x"
        ],
        size: size
    });
};

const EmptyEstimationHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyEstimation_144.webp",
        responsiveSrc: [
            "hero/EmptyEstimation_144.webp 1x",
            "hero/EmptyEstimation_288.webp 2x",
            "hero/EmptyEstimation_432.webp 3x"
        ],
        size: size
    });
};

const EmptyFindYourAddressHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyFindYourAddress_144.webp",
        responsiveSrc: [
            "hero/EmptyFindYourAddress_144.webp 1x",
            "hero/EmptyFindYourAddress_288.webp 2x",
            "hero/EmptyFindYourAddress_432.webp 3x"
        ],
        size: size
    });
};

const EmptyListingOfflineHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyListingOffline_144.webp",
        responsiveSrc: [
            "hero/EmptyListingOffline_144.webp 1x",
            "hero/EmptyListingOffline_288.webp 2x",
            "hero/EmptyListingOffline_432.webp 3x"
        ],
        size: size
    });
};

const EmptyListingRemovedHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyListingRemoved_144.webp",
        responsiveSrc: [
            "hero/EmptyListingRemoved_144.webp 1x",
            "hero/EmptyListingRemoved_288.webp 2x",
            "hero/EmptyListingRemoved_432.webp 3x"
        ],
        size: size
    });
};

const EmptyNoAlertHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyNoAlert_144.webp",
        responsiveSrc: [
            "hero/EmptyNoAlert_144.webp 1x",
            "hero/EmptyNoAlert_288.webp 2x",
            "hero/EmptyNoAlert_432.webp 3x"
        ],
        size: size
    });
};

const EmptyNoLeadsHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyNoLeads_144.webp",
        responsiveSrc: [
            "hero/EmptyNoLeads_144.webp 1x",
            "hero/EmptyNoLeads_288.webp 2x",
            "hero/EmptyNoLeads_432.webp 3x"
        ],
        size: size
    });
};

const EmptyNoListingYetHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyNoListingYet_144.webp",
        responsiveSrc: [
            "hero/EmptyNoListingYet_144.webp 1x",
            "hero/EmptyNoListingYet_288.webp 2x",
            "hero/EmptyNoListingYet_432.webp 3x"
        ],
        size: size
    });
};

const EmptyNoMessageYetHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyNoMessageYet_144.webp",
        responsiveSrc: [
            "hero/EmptyNoMessageYet_144.webp 1x",
            "hero/EmptyNoMessageYet_288.webp 2x",
            "hero/EmptyNoMessageYet_432.webp 3x"
        ],
        size: size
    });
};

const EmptyNoResultsFoundHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyNoResultsFound_144.webp",
        responsiveSrc: [
            "hero/EmptyNoResultsFound_144.webp 1x",
            "hero/EmptyNoResultsFound_288.webp 2x",
            "hero/EmptyNoResultsFound_432.webp 3x"
        ],
        size: size
    });
};

const EmptyNoReviewsAgencyHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyNoReviewsAgency_144.webp",
        responsiveSrc: [
            "hero/EmptyNoReviewsAgency_144.webp 1x",
            "hero/EmptyNoReviewsAgency_288.webp 2x",
            "hero/EmptyNoReviewsAgency_432.webp 3x"
        ],
        size: size
    });
};

const EmptyPropertyNoLoadingHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyPropertyNoLoading_144.webp",
        responsiveSrc: [
            "hero/EmptyPropertyNoLoading_144.webp 1x",
            "hero/EmptyPropertyNoLoading_288.webp 2x",
            "hero/EmptyPropertyNoLoading_432.webp 3x"
        ],
        size: size
    });
};

const EmptyPropertyNotFoundHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/EmptyPropertyNotFound_144.webp",
        responsiveSrc: [
            "hero/EmptyPropertyNotFound_144.webp 1x",
            "hero/EmptyPropertyNotFound_288.webp 2x",
            "hero/EmptyPropertyNotFound_432.webp 3x"
        ],
        size: size
    });
};

const Error404Hero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/Error404_144.webp",
        responsiveSrc: [
            "hero/Error404_144.webp 1x",
            "hero/Error404_288.webp 2x",
            "hero/Error404_432.webp 3x"
        ],
        size: size
    });
};

const Error500Hero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/Error500_144.webp",
        responsiveSrc: [
            "hero/Error500_144.webp 1x",
            "hero/Error500_288.webp 2x",
            "hero/Error500_432.webp 3x"
        ],
        size: size
    });
};

const ErrorCancelSubscriptionHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorCancelSubscription_144.webp",
        responsiveSrc: [
            "hero/ErrorCancelSubscription_144.webp 1x",
            "hero/ErrorCancelSubscription_288.webp 2x",
            "hero/ErrorCancelSubscription_432.webp 3x"
        ],
        size: size
    });
};

const ErrorDeviceNotSupportedHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorDeviceNotSupported_144.webp",
        responsiveSrc: [
            "hero/ErrorDeviceNotSupported_144.webp 1x",
            "hero/ErrorDeviceNotSupported_288.webp 2x",
            "hero/ErrorDeviceNotSupported_432.webp 3x"
        ],
        size: size
    });
};

const ErrorFavoritesUnavailableHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorFavoritesUnavailable_144.webp",
        responsiveSrc: [
            "hero/ErrorFavoritesUnavailable_144.webp 1x",
            "hero/ErrorFavoritesUnavailable_288.webp 2x",
            "hero/ErrorFavoritesUnavailable_432.webp 3x"
        ],
        size: size
    });
};

const ErrorListingOfflineHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorListingOffline_144.webp",
        responsiveSrc: [
            "hero/ErrorListingOffline_144.webp 1x",
            "hero/ErrorListingOffline_288.webp 2x",
            "hero/ErrorListingOffline_432.webp 3x"
        ],
        size: size
    });
};

const ErrorLoginViewHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorLoginView_144.webp",
        responsiveSrc: [
            "hero/ErrorLoginView_144.webp 1x",
            "hero/ErrorLoginView_288.webp 2x",
            "hero/ErrorLoginView_432.webp 3x"
        ],
        size: size
    });
};

const ErrorMapUnavailableHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorMapUnavailable_144.webp",
        responsiveSrc: [
            "hero/ErrorMapUnavailable_144.webp 1x",
            "hero/ErrorMapUnavailable_288.webp 2x",
            "hero/ErrorMapUnavailable_432.webp 3x"
        ],
        size: size
    });
};

const ErrorMisssingPageHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorMisssingPage_144.webp",
        responsiveSrc: [
            "hero/ErrorMisssingPage_144.webp 1x",
            "hero/ErrorMisssingPage_288.webp 2x",
            "hero/ErrorMisssingPage_432.webp 3x"
        ],
        size: size
    });
};

const ErrorNoInternetConnectionHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorNoInternetConnection_144.webp",
        responsiveSrc: [
            "hero/ErrorNoInternetConnection_144.webp 1x",
            "hero/ErrorNoInternetConnection_288.webp 2x",
            "hero/ErrorNoInternetConnection_432.webp 3x"
        ],
        size: size
    });
};

const ErrorNoServiceHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorNoService_144.webp",
        responsiveSrc: [
            "hero/ErrorNoService_144.webp 1x",
            "hero/ErrorNoService_288.webp 2x",
            "hero/ErrorNoService_432.webp 3x"
        ],
        size: size
    });
};

const ErrorPageUnavailableHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorPageUnavailable_144.webp",
        responsiveSrc: [
            "hero/ErrorPageUnavailable_144.webp 1x",
            "hero/ErrorPageUnavailable_288.webp 2x",
            "hero/ErrorPageUnavailable_432.webp 3x"
        ],
        size: size
    });
};

const ErrorPriceUnavailableHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorPriceUnavailable_144.webp",
        responsiveSrc: [
            "hero/ErrorPriceUnavailable_144.webp 1x",
            "hero/ErrorPriceUnavailable_288.webp 2x",
            "hero/ErrorPriceUnavailable_432.webp 3x"
        ],
        size: size
    });
};

const ErrorSearchNotAvailableHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorSearchNotAvailable_144.webp",
        responsiveSrc: [
            "hero/ErrorSearchNotAvailable_144.webp 1x",
            "hero/ErrorSearchNotAvailable_288.webp 2x",
            "hero/ErrorSearchNotAvailable_432.webp 3x"
        ],
        size: size
    });
};

const ErrorSomethingWentWrongHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorSomethingWentWrong_144.webp",
        responsiveSrc: [
            "hero/ErrorSomethingWentWrong_144.webp 1x",
            "hero/ErrorSomethingWentWrong_288.webp 2x",
            "hero/ErrorSomethingWentWrong_432.webp 3x"
        ],
        size: size
    });
};

const ErrorUnpaidInvoicesHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/ErrorUnpaidInvoices_144.webp",
        responsiveSrc: [
            "hero/ErrorUnpaidInvoices_144.webp 1x",
            "hero/ErrorUnpaidInvoices_288.webp 2x",
            "hero/ErrorUnpaidInvoices_432.webp 3x"
        ],
        size: size
    });
};

const InfoAddNoteRateHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoAddNoteRate_144.webp",
        responsiveSrc: [
            "hero/InfoAddNoteRate_144.webp 1x",
            "hero/InfoAddNoteRate_288.webp 2x",
            "hero/InfoAddNoteRate_432.webp 3x"
        ],
        size: size
    });
};

const InfoAgencyContactHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoAgencyContact_144.webp",
        responsiveSrc: [
            "hero/InfoAgencyContact_144.webp 1x",
            "hero/InfoAgencyContact_288.webp 2x",
            "hero/InfoAgencyContact_432.webp 3x"
        ],
        size: size
    });
};

const InfoAlertAddImageHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoAlertAddImage_144.webp",
        responsiveSrc: [
            "hero/InfoAlertAddImage_144.webp 1x",
            "hero/InfoAlertAddImage_288.webp 2x",
            "hero/InfoAlertAddImage_432.webp 3x"
        ],
        size: size
    });
};

const InfoAlmostThereHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoAlmostThere_144.webp",
        responsiveSrc: [
            "hero/InfoAlmostThere_144.webp 1x",
            "hero/InfoAlmostThere_288.webp 2x",
            "hero/InfoAlmostThere_432.webp 3x"
        ],
        size: size
    });
};

const InfoAudienceHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoAudience_144.webp",
        responsiveSrc: [
            "hero/InfoAudience_144.webp 1x",
            "hero/InfoAudience_288.webp 2x",
            "hero/InfoAudience_432.webp 3x"
        ],
        size: size
    });
};

const InfoCancelSubscriptionHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoCancelSubscription_144.webp",
        responsiveSrc: [
            "hero/InfoCancelSubscription_144.webp 1x",
            "hero/InfoCancelSubscription_288.webp 2x",
            "hero/InfoCancelSubscription_432.webp 3x"
        ],
        size: size
    });
};

const InfoConfirmEmailHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoConfirmEmail_144.webp",
        responsiveSrc: [
            "hero/InfoConfirmEmail_144.webp 1x",
            "hero/InfoConfirmEmail_288.webp 2x",
            "hero/InfoConfirmEmail_432.webp 3x"
        ],
        size: size
    });
};

const InfoCreateANoteHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoCreateANote_144.webp",
        responsiveSrc: [
            "hero/InfoCreateANote_144.webp 1x",
            "hero/InfoCreateANote_288.webp 2x",
            "hero/InfoCreateANote_432.webp 3x"
        ],
        size: size
    });
};

const InfoEmailSentHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoEmailSent_144.webp",
        responsiveSrc: [
            "hero/InfoEmailSent_144.webp 1x",
            "hero/InfoEmailSent_288.webp 2x",
            "hero/InfoEmailSent_432.webp 3x"
        ],
        size: size
    });
};

const InfoEnergyRenovationHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoEnergyRenovation_144.webp",
        responsiveSrc: [
            "hero/InfoEnergyRenovation_144.webp 1x",
            "hero/InfoEnergyRenovation_288.webp 2x",
            "hero/InfoEnergyRenovation_432.webp 3x"
        ],
        size: size
    });
};

const InfoExpandYourSearchHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoExpandYourSearch_144.webp",
        responsiveSrc: [
            "hero/InfoExpandYourSearch_144.webp 1x",
            "hero/InfoExpandYourSearch_288.webp 2x",
            "hero/InfoExpandYourSearch_432.webp 3x"
        ],
        size: size
    });
};

const InfoFeedbackHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoFeedback_144.webp",
        responsiveSrc: [
            "hero/InfoFeedback_144.webp 1x",
            "hero/InfoFeedback_288.webp 2x",
            "hero/InfoFeedback_432.webp 3x"
        ],
        size: size
    });
};

const InfoFeedbackTwoHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoFeedbackTwo_144.webp",
        responsiveSrc: [
            "hero/InfoFeedbackTwo_144.webp 1x",
            "hero/InfoFeedbackTwo_288.webp 2x",
            "hero/InfoFeedbackTwo_432.webp 3x"
        ],
        size: size
    });
};

const InfoFetchPropertyHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoFetchProperty_144.webp",
        responsiveSrc: [
            "hero/InfoFetchProperty_144.webp 1x",
            "hero/InfoFetchProperty_288.webp 2x",
            "hero/InfoFetchProperty_432.webp 3x"
        ],
        size: size
    });
};

const InfoFindYourAddressHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoFindYourAddress_144.webp",
        responsiveSrc: [
            "hero/InfoFindYourAddress_144.webp 1x",
            "hero/InfoFindYourAddress_288.webp 2x",
            "hero/InfoFindYourAddress_432.webp 3x"
        ],
        size: size
    });
};

const InfoFindYourAgencyHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoFindYourAgency_144.webp",
        responsiveSrc: [
            "hero/InfoFindYourAgency_144.webp 1x",
            "hero/InfoFindYourAgency_288.webp 2x",
            "hero/InfoFindYourAgency_432.webp 3x"
        ],
        size: size
    });
};

const InfoFirstAlertHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoFirstAlert_144.webp",
        responsiveSrc: [
            "hero/InfoFirstAlert_144.webp 1x",
            "hero/InfoFirstAlert_288.webp 2x",
            "hero/InfoFirstAlert_432.webp 3x"
        ],
        size: size
    });
};

const InfoFirstToKnowHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoFirstToKnow_144.webp",
        responsiveSrc: [
            "hero/InfoFirstToKnow_144.webp 1x",
            "hero/InfoFirstToKnow_288.webp 2x",
            "hero/InfoFirstToKnow_432.webp 3x"
        ],
        size: size
    });
};

const InfoHouseHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoHouse_144.webp",
        responsiveSrc: [
            "hero/InfoHouse_144.webp 1x",
            "hero/InfoHouse_288.webp 2x",
            "hero/InfoHouse_432.webp 3x"
        ],
        size: size
    });
};

const InfoMaintenanceHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoMaintenance_144.webp",
        responsiveSrc: [
            "hero/InfoMaintenance_144.webp 1x",
            "hero/InfoMaintenance_288.webp 2x",
            "hero/InfoMaintenance_432.webp 3x"
        ],
        size: size
    });
};

const InfoManagePropertiesHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoManageProperties_144.webp",
        responsiveSrc: [
            "hero/InfoManageProperties_144.webp 1x",
            "hero/InfoManageProperties_288.webp 2x",
            "hero/InfoManageProperties_432.webp 3x"
        ],
        size: size
    });
};

const InfoMoneyHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoMoney_144.webp",
        responsiveSrc: [
            "hero/InfoMoney_144.webp 1x",
            "hero/InfoMoney_288.webp 2x",
            "hero/InfoMoney_432.webp 3x"
        ],
        size: size
    });
};

const InfoNeedHelpHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoNeedHelp_144.webp",
        responsiveSrc: [
            "hero/InfoNeedHelp_144.webp 1x",
            "hero/InfoNeedHelp_288.webp 2x",
            "hero/InfoNeedHelp_432.webp 3x"
        ],
        size: size
    });
};

const InfoNoListingB2BHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoNoListingB2B_144.webp",
        responsiveSrc: [
            "hero/InfoNoListingB2B_144.webp 1x",
            "hero/InfoNoListingB2B_288.webp 2x",
            "hero/InfoNoListingB2B_432.webp 3x"
        ],
        size: size
    });
};

const InfoNotificationMessageHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoNotificationMessage_144.webp",
        responsiveSrc: [
            "hero/InfoNotificationMessage_144.webp 1x",
            "hero/InfoNotificationMessage_288.webp 2x",
            "hero/InfoNotificationMessage_432.webp 3x"
        ],
        size: size
    });
};

const InfoProfileHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoProfile_144.webp",
        responsiveSrc: [
            "hero/InfoProfile_144.webp 1x",
            "hero/InfoProfile_288.webp 2x",
            "hero/InfoProfile_432.webp 3x"
        ],
        size: size
    });
};

const InfoQuitSaveHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoQuitSave_144.webp",
        responsiveSrc: [
            "hero/InfoQuitSave_144.webp 1x",
            "hero/InfoQuitSave_288.webp 2x",
            "hero/InfoQuitSave_432.webp 3x"
        ],
        size: size
    });
};

const InfoQuittingHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoQuitting_144.webp",
        responsiveSrc: [
            "hero/InfoQuitting_144.webp 1x",
            "hero/InfoQuitting_288.webp 2x",
            "hero/InfoQuitting_432.webp 3x"
        ],
        size: size
    });
};

const InfoReceiveEmailHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoReceiveEmail_144.webp",
        responsiveSrc: [
            "hero/InfoReceiveEmail_144.webp 1x",
            "hero/InfoReceiveEmail_288.webp 2x",
            "hero/InfoReceiveEmail_432.webp 3x"
        ],
        size: size
    });
};

const InfoRentOutYourPropertyHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoRentOutYourProperty_144.webp",
        responsiveSrc: [
            "hero/InfoRentOutYourProperty_144.webp 1x",
            "hero/InfoRentOutYourProperty_288.webp 2x",
            "hero/InfoRentOutYourProperty_432.webp 3x"
        ],
        size: size
    });
};

const InfoResetConsumerPortalHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoResetConsumerPortal_144.webp",
        responsiveSrc: [
            "hero/InfoResetConsumerPortal_144.webp 1x",
            "hero/InfoResetConsumerPortal_288.webp 2x",
            "hero/InfoResetConsumerPortal_432.webp 3x"
        ],
        size: size
    });
};

const InfoResetPasswordEmailHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoResetPasswordEmail_144.webp",
        responsiveSrc: [
            "hero/InfoResetPasswordEmail_144.webp 1x",
            "hero/InfoResetPasswordEmail_288.webp 2x",
            "hero/InfoResetPasswordEmail_432.webp 3x"
        ],
        size: size
    });
};

const InfoResubscribeEmailHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoResubscribeEmail_144.webp",
        responsiveSrc: [
            "hero/InfoResubscribeEmail_144.webp 1x",
            "hero/InfoResubscribeEmail_288.webp 2x",
            "hero/InfoResubscribeEmail_432.webp 3x"
        ],
        size: size
    });
};

const InfoSearchHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoSearch_144.webp",
        responsiveSrc: [
            "hero/InfoSearch_144.webp 1x",
            "hero/InfoSearch_288.webp 2x",
            "hero/InfoSearch_432.webp 3x"
        ],
        size: size
    });
};

const InfoServiceNotPermitedHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoServiceNotPermited_144.webp",
        responsiveSrc: [
            "hero/InfoServiceNotPermited_144.webp 1x",
            "hero/InfoServiceNotPermited_288.webp 2x",
            "hero/InfoServiceNotPermited_432.webp 3x"
        ],
        size: size
    });
};

const InfoSignInAlertsHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoSignInAlerts_144.webp",
        responsiveSrc: [
            "hero/InfoSignInAlerts_144.webp 1x",
            "hero/InfoSignInAlerts_288.webp 2x",
            "hero/InfoSignInAlerts_432.webp 3x"
        ],
        size: size
    });
};

const InfoTransactionalEmailHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoTransactionalEmail_144.webp",
        responsiveSrc: [
            "hero/InfoTransactionalEmail_144.webp 1x",
            "hero/InfoTransactionalEmail_288.webp 2x",
            "hero/InfoTransactionalEmail_432.webp 3x"
        ],
        size: size
    });
};

const InfoVerificationCodeHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoVerificationCode_144.webp",
        responsiveSrc: [
            "hero/InfoVerificationCode_144.webp 1x",
            "hero/InfoVerificationCode_288.webp 2x",
            "hero/InfoVerificationCode_432.webp 3x"
        ],
        size: size
    });
};

const InfoWaitingContactHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoWaitingContact_144.webp",
        responsiveSrc: [
            "hero/InfoWaitingContact_144.webp 1x",
            "hero/InfoWaitingContact_288.webp 2x",
            "hero/InfoWaitingContact_432.webp 3x"
        ],
        size: size
    });
};

const InfoWelcomeMessageHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/InfoWelcomeMessage_144.webp",
        responsiveSrc: [
            "hero/InfoWelcomeMessage_144.webp 1x",
            "hero/InfoWelcomeMessage_288.webp 2x",
            "hero/InfoWelcomeMessage_432.webp 3x"
        ],
        size: size
    });
};

const LoadingCalculationHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/LoadingCalculation_144.webp",
        responsiveSrc: [
            "hero/LoadingCalculation_144.webp 1x",
            "hero/LoadingCalculation_288.webp 2x",
            "hero/LoadingCalculation_432.webp 3x"
        ],
        size: size
    });
};

const LoadingCalculationProgressHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/LoadingCalculationProgress_144.webp",
        responsiveSrc: [
            "hero/LoadingCalculationProgress_144.webp 1x",
            "hero/LoadingCalculationProgress_288.webp 2x",
            "hero/LoadingCalculationProgress_432.webp 3x"
        ],
        size: size
    });
};

const LoadingFastHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/LoadingFast_144.webp",
        responsiveSrc: [
            "hero/LoadingFast_144.webp 1x",
            "hero/LoadingFast_288.webp 2x",
            "hero/LoadingFast_432.webp 3x"
        ],
        size: size
    });
};

const LoadingForcedUpdateHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/LoadingForcedUpdate_144.webp",
        responsiveSrc: [
            "hero/LoadingForcedUpdate_144.webp 1x",
            "hero/LoadingForcedUpdate_288.webp 2x",
            "hero/LoadingForcedUpdate_432.webp 3x"
        ],
        size: size
    });
};

const LoadingProfileHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/LoadingProfile_144.webp",
        responsiveSrc: [
            "hero/LoadingProfile_144.webp 1x",
            "hero/LoadingProfile_288.webp 2x",
            "hero/LoadingProfile_432.webp 3x"
        ],
        size: size
    });
};

const LoadingSlowHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/LoadingSlow_144.webp",
        responsiveSrc: [
            "hero/LoadingSlow_144.webp 1x",
            "hero/LoadingSlow_288.webp 2x",
            "hero/LoadingSlow_432.webp 3x"
        ],
        size: size
    });
};

const SelectionAddPicturesHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionAddPictures_144.webp",
        responsiveSrc: [
            "hero/SelectionAddPictures_144.webp 1x",
            "hero/SelectionAddPictures_288.webp 2x",
            "hero/SelectionAddPictures_432.webp 3x"
        ],
        size: size
    });
};

const SelectionBuildingDetailsHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionBuildingDetails_144.webp",
        responsiveSrc: [
            "hero/SelectionBuildingDetails_144.webp 1x",
            "hero/SelectionBuildingDetails_288.webp 2x",
            "hero/SelectionBuildingDetails_432.webp 3x"
        ],
        size: size
    });
};

const SelectionDescribeImageHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionDescribeImage_144.webp",
        responsiveSrc: [
            "hero/SelectionDescribeImage_144.webp 1x",
            "hero/SelectionDescribeImage_288.webp 2x",
            "hero/SelectionDescribeImage_432.webp 3x"
        ],
        size: size
    });
};

const SelectionExcatLocationHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionExcatLocation_144.webp",
        responsiveSrc: [
            "hero/SelectionExcatLocation_144.webp 1x",
            "hero/SelectionExcatLocation_288.webp 2x",
            "hero/SelectionExcatLocation_432.webp 3x"
        ],
        size: size
    });
};

const SelectionFloorLevelHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionFloorLevel_144.webp",
        responsiveSrc: [
            "hero/SelectionFloorLevel_144.webp 1x",
            "hero/SelectionFloorLevel_288.webp 2x",
            "hero/SelectionFloorLevel_432.webp 3x"
        ],
        size: size
    });
};

const SelectionForRentHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionForRent_144.webp",
        responsiveSrc: [
            "hero/SelectionForRent_144.webp 1x",
            "hero/SelectionForRent_288.webp 2x",
            "hero/SelectionForRent_432.webp 3x"
        ],
        size: size
    });
};

const SelectionForSellHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionForSell_144.webp",
        responsiveSrc: [
            "hero/SelectionForSell_144.webp 1x",
            "hero/SelectionForSell_288.webp 2x",
            "hero/SelectionForSell_432.webp 3x"
        ],
        size: size
    });
};

const SelectionIndividualHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionIndividual_144.webp",
        responsiveSrc: [
            "hero/SelectionIndividual_144.webp 1x",
            "hero/SelectionIndividual_288.webp 2x",
            "hero/SelectionIndividual_432.webp 3x"
        ],
        size: size
    });
};

const SelectionProfessionalHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionProfessional_144.webp",
        responsiveSrc: [
            "hero/SelectionProfessional_144.webp 1x",
            "hero/SelectionProfessional_288.webp 2x",
            "hero/SelectionProfessional_432.webp 3x"
        ],
        size: size
    });
};

const SelectionProperty1FacadeHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionProperty1Facade_144.webp",
        responsiveSrc: [
            "hero/SelectionProperty1Facade_144.webp 1x",
            "hero/SelectionProperty1Facade_288.webp 2x",
            "hero/SelectionProperty1Facade_432.webp 3x"
        ],
        size: size
    });
};

const SelectionProperty2FacadeHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionProperty2Facade_144.webp",
        responsiveSrc: [
            "hero/SelectionProperty2Facade_144.webp 1x",
            "hero/SelectionProperty2Facade_288.webp 2x",
            "hero/SelectionProperty2Facade_432.webp 3x"
        ],
        size: size
    });
};

const SelectionProperty3FacadeHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionProperty3Facade_144.webp",
        responsiveSrc: [
            "hero/SelectionProperty3Facade_144.webp 1x",
            "hero/SelectionProperty3Facade_288.webp 2x",
            "hero/SelectionProperty3Facade_432.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyApartmentHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionPropertyApartment_144.webp",
        responsiveSrc: [
            "hero/SelectionPropertyApartment_144.webp 1x",
            "hero/SelectionPropertyApartment_288.webp 2x",
            "hero/SelectionPropertyApartment_432.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyClearViewHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionPropertyClearView_144.webp",
        responsiveSrc: [
            "hero/SelectionPropertyClearView_144.webp 1x",
            "hero/SelectionPropertyClearView_288.webp 2x",
            "hero/SelectionPropertyClearView_432.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyExceptionalViewHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionPropertyExceptionalView_144.webp",
        responsiveSrc: [
            "hero/SelectionPropertyExceptionalView_144.webp 1x",
            "hero/SelectionPropertyExceptionalView_288.webp 2x",
            "hero/SelectionPropertyExceptionalView_432.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyHouseHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionPropertyHouse_144.webp",
        responsiveSrc: [
            "hero/SelectionPropertyHouse_144.webp 1x",
            "hero/SelectionPropertyHouse_288.webp 2x",
            "hero/SelectionPropertyHouse_432.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyObstructedViewHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionPropertyObstructedView_144.webp",
        responsiveSrc: [
            "hero/SelectionPropertyObstructedView_144.webp 1x",
            "hero/SelectionPropertyObstructedView_288.webp 2x",
            "hero/SelectionPropertyObstructedView_432.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyParkingGarageHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionPropertyParkingGarage_144.webp",
        responsiveSrc: [
            "hero/SelectionPropertyParkingGarage_144.webp 1x",
            "hero/SelectionPropertyParkingGarage_288.webp 2x",
            "hero/SelectionPropertyParkingGarage_432.webp 3x"
        ],
        size: size
    });
};

const SelectionShieldHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SelectionShield_144.webp",
        responsiveSrc: [
            "hero/SelectionShield_144.webp 1x",
            "hero/SelectionShield_288.webp 2x",
            "hero/SelectionShield_432.webp 3x"
        ],
        size: size
    });
};

const SuccessAdCreatedHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessAdCreated_144.webp",
        responsiveSrc: [
            "hero/SuccessAdCreated_144.webp 1x",
            "hero/SuccessAdCreated_288.webp 2x",
            "hero/SuccessAdCreated_432.webp 3x"
        ],
        size: size
    });
};

const SuccessBusinessServicesHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessBusinessServices_144.webp",
        responsiveSrc: [
            "hero/SuccessBusinessServices_144.webp 1x",
            "hero/SuccessBusinessServices_288.webp 2x",
            "hero/SuccessBusinessServices_432.webp 3x"
        ],
        size: size
    });
};

const SuccessCalculationFinishedHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessCalculationFinished_144.webp",
        responsiveSrc: [
            "hero/SuccessCalculationFinished_144.webp 1x",
            "hero/SuccessCalculationFinished_288.webp 2x",
            "hero/SuccessCalculationFinished_432.webp 3x"
        ],
        size: size
    });
};

const SuccessCancelRefundHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessCancelRefund_144.webp",
        responsiveSrc: [
            "hero/SuccessCancelRefund_144.webp 1x",
            "hero/SuccessCancelRefund_288.webp 2x",
            "hero/SuccessCancelRefund_432.webp 3x"
        ],
        size: size
    });
};

const SuccessConfirmPurchaseHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessConfirmPurchase_144.webp",
        responsiveSrc: [
            "hero/SuccessConfirmPurchase_144.webp 1x",
            "hero/SuccessConfirmPurchase_288.webp 2x",
            "hero/SuccessConfirmPurchase_432.webp 3x"
        ],
        size: size
    });
};

const SuccessEmailConfirmationHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessEmailConfirmation_144.webp",
        responsiveSrc: [
            "hero/SuccessEmailConfirmation_144.webp 1x",
            "hero/SuccessEmailConfirmation_288.webp 2x",
            "hero/SuccessEmailConfirmation_432.webp 3x"
        ],
        size: size
    });
};

const SuccessEstimationResultCardHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessEstimationResultCard_144.webp",
        responsiveSrc: [
            "hero/SuccessEstimationResultCard_144.webp 1x",
            "hero/SuccessEstimationResultCard_288.webp 2x",
            "hero/SuccessEstimationResultCard_432.webp 3x"
        ],
        size: size
    });
};

const SuccessFindAClassifiedHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessFindAClassified_144.webp",
        responsiveSrc: [
            "hero/SuccessFindAClassified_144.webp 1x",
            "hero/SuccessFindAClassified_288.webp 2x",
            "hero/SuccessFindAClassified_432.webp 3x"
        ],
        size: size
    });
};

const SuccessFindALeadHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessFindALead_144.webp",
        responsiveSrc: [
            "hero/SuccessFindALead_144.webp 1x",
            "hero/SuccessFindALead_288.webp 2x",
            "hero/SuccessFindALead_432.webp 3x"
        ],
        size: size
    });
};

const SuccessFindATransactionHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessFindATransaction_144.webp",
        responsiveSrc: [
            "hero/SuccessFindATransaction_144.webp 1x",
            "hero/SuccessFindATransaction_288.webp 2x",
            "hero/SuccessFindATransaction_432.webp 3x"
        ],
        size: size
    });
};

const SuccessFindAUserHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessFindAUser_144.webp",
        responsiveSrc: [
            "hero/SuccessFindAUser_144.webp 1x",
            "hero/SuccessFindAUser_288.webp 2x",
            "hero/SuccessFindAUser_432.webp 3x"
        ],
        size: size
    });
};

const SuccessListingStandOutHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessListingStandOut_144.webp",
        responsiveSrc: [
            "hero/SuccessListingStandOut_144.webp 1x",
            "hero/SuccessListingStandOut_288.webp 2x",
            "hero/SuccessListingStandOut_432.webp 3x"
        ],
        size: size
    });
};

const SuccessMapDiscoveryHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessMapDiscovery_144.webp",
        responsiveSrc: [
            "hero/SuccessMapDiscovery_144.webp 1x",
            "hero/SuccessMapDiscovery_288.webp 2x",
            "hero/SuccessMapDiscovery_432.webp 3x"
        ],
        size: size
    });
};

const SuccessNotificationsValueHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessNotificationsValue_144.webp",
        responsiveSrc: [
            "hero/SuccessNotificationsValue_144.webp 1x",
            "hero/SuccessNotificationsValue_288.webp 2x",
            "hero/SuccessNotificationsValue_432.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyAlreadyEstimatedHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessPropertyAlreadyEstimated_144.webp",
        responsiveSrc: [
            "hero/SuccessPropertyAlreadyEstimated_144.webp 1x",
            "hero/SuccessPropertyAlreadyEstimated_288.webp 2x",
            "hero/SuccessPropertyAlreadyEstimated_432.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyBuildingHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessPropertyBuilding_144.webp",
        responsiveSrc: [
            "hero/SuccessPropertyBuilding_144.webp 1x",
            "hero/SuccessPropertyBuilding_288.webp 2x",
            "hero/SuccessPropertyBuilding_432.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyEstimationHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessPropertyEstimation_144.webp",
        responsiveSrc: [
            "hero/SuccessPropertyEstimation_144.webp 1x",
            "hero/SuccessPropertyEstimation_288.webp 2x",
            "hero/SuccessPropertyEstimation_432.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyFlatEstimationHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessPropertyFlatEstimation_144.webp",
        responsiveSrc: [
            "hero/SuccessPropertyFlatEstimation_144.webp 1x",
            "hero/SuccessPropertyFlatEstimation_288.webp 2x",
            "hero/SuccessPropertyFlatEstimation_432.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyHouseHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessPropertyHouse_144.webp",
        responsiveSrc: [
            "hero/SuccessPropertyHouse_144.webp 1x",
            "hero/SuccessPropertyHouse_288.webp 2x",
            "hero/SuccessPropertyHouse_432.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertySearchHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessPropertySearch_144.webp",
        responsiveSrc: [
            "hero/SuccessPropertySearch_144.webp 1x",
            "hero/SuccessPropertySearch_288.webp 2x",
            "hero/SuccessPropertySearch_432.webp 3x"
        ],
        size: size
    });
};

const SuccessThankYouRequestHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessThankYouRequest_144.webp",
        responsiveSrc: [
            "hero/SuccessThankYouRequest_144.webp 1x",
            "hero/SuccessThankYouRequest_288.webp 2x",
            "hero/SuccessThankYouRequest_432.webp 3x"
        ],
        size: size
    });
};

const SuccessWelcomeLeadToolHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessWelcomeLeadTool_144.webp",
        responsiveSrc: [
            "hero/SuccessWelcomeLeadTool_144.webp 1x",
            "hero/SuccessWelcomeLeadTool_288.webp 2x",
            "hero/SuccessWelcomeLeadTool_432.webp 3x"
        ],
        size: size
    });
};

const SuccessWelcomeSellerManagementHero = ({ size = "144", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "hero/SuccessWelcomeSellerManagement_144.webp",
        responsiveSrc: [
            "hero/SuccessWelcomeSellerManagement_144.webp 1x",
            "hero/SuccessWelcomeSellerManagement_288.webp 2x",
            "hero/SuccessWelcomeSellerManagement_432.webp 3x"
        ],
        size: size
    });
};

const EmptyAgencyReviewsNoLoadingPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyAgencyReviewsNoLoading_96.webp",
        responsiveSrc: [
            "picto/EmptyAgencyReviewsNoLoading_96.webp 1x",
            "picto/EmptyAgencyReviewsNoLoading_192.webp 2x",
            "picto/EmptyAgencyReviewsNoLoading_288.webp 3x"
        ],
        size: size
    });
};

const EmptyEstimationPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyEstimation_96.webp",
        responsiveSrc: [
            "picto/EmptyEstimation_96.webp 1x",
            "picto/EmptyEstimation_192.webp 2x",
            "picto/EmptyEstimation_288.webp 3x"
        ],
        size: size
    });
};

const EmptyFindYourAddressPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyFindYourAddress_96.webp",
        responsiveSrc: [
            "picto/EmptyFindYourAddress_96.webp 1x",
            "picto/EmptyFindYourAddress_192.webp 2x",
            "picto/EmptyFindYourAddress_288.webp 3x"
        ],
        size: size
    });
};

const EmptyListingOfflinePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyListingOffline_96.webp",
        responsiveSrc: [
            "picto/EmptyListingOffline_96.webp 1x",
            "picto/EmptyListingOffline_192.webp 2x",
            "picto/EmptyListingOffline_288.webp 3x"
        ],
        size: size
    });
};

const EmptyListingRemovedPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyListingRemoved_96.webp",
        responsiveSrc: [
            "picto/EmptyListingRemoved_96.webp 1x",
            "picto/EmptyListingRemoved_192.webp 2x",
            "picto/EmptyListingRemoved_288.webp 3x"
        ],
        size: size
    });
};

const EmptyNoAlertPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyNoAlert_96.webp",
        responsiveSrc: [
            "picto/EmptyNoAlert_96.webp 1x",
            "picto/EmptyNoAlert_192.webp 2x",
            "picto/EmptyNoAlert_288.webp 3x"
        ],
        size: size
    });
};

const EmptyNoLeadsPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyNoLeads_96.webp",
        responsiveSrc: [
            "picto/EmptyNoLeads_96.webp 1x",
            "picto/EmptyNoLeads_192.webp 2x",
            "picto/EmptyNoLeads_288.webp 3x"
        ],
        size: size
    });
};

const EmptyNoListingYetPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyNoListingYet_96.webp",
        responsiveSrc: [
            "picto/EmptyNoListingYet_96.webp 1x",
            "picto/EmptyNoListingYet_192.webp 2x",
            "picto/EmptyNoListingYet_288.webp 3x"
        ],
        size: size
    });
};

const EmptyNoMessageYetPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyNoMessageYet_96.webp",
        responsiveSrc: [
            "picto/EmptyNoMessageYet_96.webp 1x",
            "picto/EmptyNoMessageYet_192.webp 2x",
            "picto/EmptyNoMessageYet_288.webp 3x"
        ],
        size: size
    });
};

const EmptyNoResultsFoundPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyNoResultsFound_96.webp",
        responsiveSrc: [
            "picto/EmptyNoResultsFound_96.webp 1x",
            "picto/EmptyNoResultsFound_192.webp 2x",
            "picto/EmptyNoResultsFound_288.webp 3x"
        ],
        size: size
    });
};

const EmptyNoReviewsAgencyPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyNoReviewsAgency_96.webp",
        responsiveSrc: [
            "picto/EmptyNoReviewsAgency_96.webp 1x",
            "picto/EmptyNoReviewsAgency_192.webp 2x",
            "picto/EmptyNoReviewsAgency_288.webp 3x"
        ],
        size: size
    });
};

const EmptyPropertyNoLoadingPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyPropertyNoLoading_96.webp",
        responsiveSrc: [
            "picto/EmptyPropertyNoLoading_96.webp 1x",
            "picto/EmptyPropertyNoLoading_192.webp 2x",
            "picto/EmptyPropertyNoLoading_288.webp 3x"
        ],
        size: size
    });
};

const EmptyPropertyNotFoundPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/EmptyPropertyNotFound_96.webp",
        responsiveSrc: [
            "picto/EmptyPropertyNotFound_96.webp 1x",
            "picto/EmptyPropertyNotFound_192.webp 2x",
            "picto/EmptyPropertyNotFound_288.webp 3x"
        ],
        size: size
    });
};

const Error404Picto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/Error404_96.webp",
        responsiveSrc: [
            "picto/Error404_96.webp 1x",
            "picto/Error404_192.webp 2x",
            "picto/Error404_288.webp 3x"
        ],
        size: size
    });
};

const Error500Picto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/Error500_96.webp",
        responsiveSrc: [
            "picto/Error500_96.webp 1x",
            "picto/Error500_192.webp 2x",
            "picto/Error500_288.webp 3x"
        ],
        size: size
    });
};

const ErrorCancelSubscriptionPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorCancelSubscription_96.webp",
        responsiveSrc: [
            "picto/ErrorCancelSubscription_96.webp 1x",
            "picto/ErrorCancelSubscription_192.webp 2x",
            "picto/ErrorCancelSubscription_288.webp 3x"
        ],
        size: size
    });
};

const ErrorDeviceNotSupportedPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorDeviceNotSupported_96.webp",
        responsiveSrc: [
            "picto/ErrorDeviceNotSupported_96.webp 1x",
            "picto/ErrorDeviceNotSupported_192.webp 2x",
            "picto/ErrorDeviceNotSupported_288.webp 3x"
        ],
        size: size
    });
};

const ErrorFavoritesUnavailablePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorFavoritesUnavailable_96.webp",
        responsiveSrc: [
            "picto/ErrorFavoritesUnavailable_96.webp 1x",
            "picto/ErrorFavoritesUnavailable_192.webp 2x",
            "picto/ErrorFavoritesUnavailable_288.webp 3x"
        ],
        size: size
    });
};

const ErrorListingOfflinePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorListingOffline_96.webp",
        responsiveSrc: [
            "picto/ErrorListingOffline_96.webp 1x",
            "picto/ErrorListingOffline_192.webp 2x",
            "picto/ErrorListingOffline_288.webp 3x"
        ],
        size: size
    });
};

const ErrorLoginViewPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorLoginView_96.webp",
        responsiveSrc: [
            "picto/ErrorLoginView_96.webp 1x",
            "picto/ErrorLoginView_192.webp 2x",
            "picto/ErrorLoginView_288.webp 3x"
        ],
        size: size
    });
};

const ErrorMapUnavailablePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorMapUnavailable_96.webp",
        responsiveSrc: [
            "picto/ErrorMapUnavailable_96.webp 1x",
            "picto/ErrorMapUnavailable_192.webp 2x",
            "picto/ErrorMapUnavailable_288.webp 3x"
        ],
        size: size
    });
};

const ErrorMisssingPagePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorMisssingPage_96.webp",
        responsiveSrc: [
            "picto/ErrorMisssingPage_96.webp 1x",
            "picto/ErrorMisssingPage_192.webp 2x",
            "picto/ErrorMisssingPage_288.webp 3x"
        ],
        size: size
    });
};

const ErrorNoInternetConnectionPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorNoInternetConnection_96.webp",
        responsiveSrc: [
            "picto/ErrorNoInternetConnection_96.webp 1x",
            "picto/ErrorNoInternetConnection_192.webp 2x",
            "picto/ErrorNoInternetConnection_288.webp 3x"
        ],
        size: size
    });
};

const ErrorNoServicePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorNoService_96.webp",
        responsiveSrc: [
            "picto/ErrorNoService_96.webp 1x",
            "picto/ErrorNoService_192.webp 2x",
            "picto/ErrorNoService_288.webp 3x"
        ],
        size: size
    });
};

const ErrorPageUnavailablePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorPageUnavailable_96.webp",
        responsiveSrc: [
            "picto/ErrorPageUnavailable_96.webp 1x",
            "picto/ErrorPageUnavailable_192.webp 2x",
            "picto/ErrorPageUnavailable_288.webp 3x"
        ],
        size: size
    });
};

const ErrorPriceUnavailablePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorPriceUnavailable_96.webp",
        responsiveSrc: [
            "picto/ErrorPriceUnavailable_96.webp 1x",
            "picto/ErrorPriceUnavailable_192.webp 2x",
            "picto/ErrorPriceUnavailable_288.webp 3x"
        ],
        size: size
    });
};

const ErrorSearchNotAvailablePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorSearchNotAvailable_96.webp",
        responsiveSrc: [
            "picto/ErrorSearchNotAvailable_96.webp 1x",
            "picto/ErrorSearchNotAvailable_192.webp 2x",
            "picto/ErrorSearchNotAvailable_288.webp 3x"
        ],
        size: size
    });
};

const ErrorSomethingWentWrongPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorSomethingWentWrong_96.webp",
        responsiveSrc: [
            "picto/ErrorSomethingWentWrong_96.webp 1x",
            "picto/ErrorSomethingWentWrong_192.webp 2x",
            "picto/ErrorSomethingWentWrong_288.webp 3x"
        ],
        size: size
    });
};

const ErrorUnpaidInvoicesPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/ErrorUnpaidInvoices_96.webp",
        responsiveSrc: [
            "picto/ErrorUnpaidInvoices_96.webp 1x",
            "picto/ErrorUnpaidInvoices_192.webp 2x",
            "picto/ErrorUnpaidInvoices_288.webp 3x"
        ],
        size: size
    });
};

const InfoAddNoteRatePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoAddNoteRate_96.webp",
        responsiveSrc: [
            "picto/InfoAddNoteRate_96.webp 1x",
            "picto/InfoAddNoteRate_192.webp 2x",
            "picto/InfoAddNoteRate_288.webp 3x"
        ],
        size: size
    });
};

const InfoAgencyContactPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoAgencyContact_96.webp",
        responsiveSrc: [
            "picto/InfoAgencyContact_96.webp 1x",
            "picto/InfoAgencyContact_192.webp 2x",
            "picto/InfoAgencyContact_288.webp 3x"
        ],
        size: size
    });
};

const InfoAlertAddImagePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoAlertAddImage_96.webp",
        responsiveSrc: [
            "picto/InfoAlertAddImage_96.webp 1x",
            "picto/InfoAlertAddImage_192.webp 2x",
            "picto/InfoAlertAddImage_288.webp 3x"
        ],
        size: size
    });
};

const InfoAlmostTherePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoAlmostThere_96.webp",
        responsiveSrc: [
            "picto/InfoAlmostThere_96.webp 1x",
            "picto/InfoAlmostThere_192.webp 2x",
            "picto/InfoAlmostThere_288.webp 3x"
        ],
        size: size
    });
};

const InfoAudiencePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoAudience_96.webp",
        responsiveSrc: [
            "picto/InfoAudience_96.webp 1x",
            "picto/InfoAudience_192.webp 2x",
            "picto/InfoAudience_288.webp 3x"
        ],
        size: size
    });
};

const InfoCancelSubscriptionPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoCancelSubscription_96.webp",
        responsiveSrc: [
            "picto/InfoCancelSubscription_96.webp 1x",
            "picto/InfoCancelSubscription_192.webp 2x",
            "picto/InfoCancelSubscription_288.webp 3x"
        ],
        size: size
    });
};

const InfoConfirmEmailPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoConfirmEmail_96.webp",
        responsiveSrc: [
            "picto/InfoConfirmEmail_96.webp 1x",
            "picto/InfoConfirmEmail_192.webp 2x",
            "picto/InfoConfirmEmail_288.webp 3x"
        ],
        size: size
    });
};

const InfoCreateANotePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoCreateANote_96.webp",
        responsiveSrc: [
            "picto/InfoCreateANote_96.webp 1x",
            "picto/InfoCreateANote_192.webp 2x",
            "picto/InfoCreateANote_288.webp 3x"
        ],
        size: size
    });
};

const InfoEmailSentPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoEmailSent_96.webp",
        responsiveSrc: [
            "picto/InfoEmailSent_96.webp 1x",
            "picto/InfoEmailSent_192.webp 2x",
            "picto/InfoEmailSent_288.webp 3x"
        ],
        size: size
    });
};

const InfoEnergyRenovationPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoEnergyRenovation_96.webp",
        responsiveSrc: [
            "picto/InfoEnergyRenovation_96.webp 1x",
            "picto/InfoEnergyRenovation_192.webp 2x",
            "picto/InfoEnergyRenovation_288.webp 3x"
        ],
        size: size
    });
};

const InfoExpandYourSearchPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoExpandYourSearch_96.webp",
        responsiveSrc: [
            "picto/InfoExpandYourSearch_96.webp 1x",
            "picto/InfoExpandYourSearch_192.webp 2x",
            "picto/InfoExpandYourSearch_288.webp 3x"
        ],
        size: size
    });
};

const InfoFeedbackPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoFeedback_96.webp",
        responsiveSrc: [
            "picto/InfoFeedback_96.webp 1x",
            "picto/InfoFeedback_192.webp 2x",
            "picto/InfoFeedback_288.webp 3x"
        ],
        size: size
    });
};

const InfoFeedbackTwoPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoFeedbackTwo_96.webp",
        responsiveSrc: [
            "picto/InfoFeedbackTwo_96.webp 1x",
            "picto/InfoFeedbackTwo_192.webp 2x",
            "picto/InfoFeedbackTwo_288.webp 3x"
        ],
        size: size
    });
};

const InfoFetchPropertyPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoFetchProperty_96.webp",
        responsiveSrc: [
            "picto/InfoFetchProperty_96.webp 1x",
            "picto/InfoFetchProperty_192.webp 2x",
            "picto/InfoFetchProperty_288.webp 3x"
        ],
        size: size
    });
};

const InfoFindYourAddressPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoFindYourAddress_96.webp",
        responsiveSrc: [
            "picto/InfoFindYourAddress_96.webp 1x",
            "picto/InfoFindYourAddress_192.webp 2x",
            "picto/InfoFindYourAddress_288.webp 3x"
        ],
        size: size
    });
};

const InfoFindYourAgencyPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoFindYourAgency_96.webp",
        responsiveSrc: [
            "picto/InfoFindYourAgency_96.webp 1x",
            "picto/InfoFindYourAgency_192.webp 2x",
            "picto/InfoFindYourAgency_288.webp 3x"
        ],
        size: size
    });
};

const InfoFirstAlertPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoFirstAlert_96.webp",
        responsiveSrc: [
            "picto/InfoFirstAlert_96.webp 1x",
            "picto/InfoFirstAlert_192.webp 2x",
            "picto/InfoFirstAlert_288.webp 3x"
        ],
        size: size
    });
};

const InfoFirstToKnowPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoFirstToKnow_96.webp",
        responsiveSrc: [
            "picto/InfoFirstToKnow_96.webp 1x",
            "picto/InfoFirstToKnow_192.webp 2x",
            "picto/InfoFirstToKnow_288.webp 3x"
        ],
        size: size
    });
};

const InfoHousePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoHouse_96.webp",
        responsiveSrc: [
            "picto/InfoHouse_96.webp 1x",
            "picto/InfoHouse_192.webp 2x",
            "picto/InfoHouse_288.webp 3x"
        ],
        size: size
    });
};

const InfoMaintenancePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoMaintenance_96.webp",
        responsiveSrc: [
            "picto/InfoMaintenance_96.webp 1x",
            "picto/InfoMaintenance_192.webp 2x",
            "picto/InfoMaintenance_288.webp 3x"
        ],
        size: size
    });
};

const InfoManagePropertiesPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoManageProperties_96.webp",
        responsiveSrc: [
            "picto/InfoManageProperties_96.webp 1x",
            "picto/InfoManageProperties_192.webp 2x",
            "picto/InfoManageProperties_288.webp 3x"
        ],
        size: size
    });
};

const InfoMoneyPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoMoney_96.webp",
        responsiveSrc: [
            "picto/InfoMoney_96.webp 1x",
            "picto/InfoMoney_192.webp 2x",
            "picto/InfoMoney_288.webp 3x"
        ],
        size: size
    });
};

const InfoNeedHelpPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoNeedHelp_96.webp",
        responsiveSrc: [
            "picto/InfoNeedHelp_96.webp 1x",
            "picto/InfoNeedHelp_192.webp 2x",
            "picto/InfoNeedHelp_288.webp 3x"
        ],
        size: size
    });
};

const InfoNoListingB2BPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoNoListingB2B_96.webp",
        responsiveSrc: [
            "picto/InfoNoListingB2B_96.webp 1x",
            "picto/InfoNoListingB2B_192.webp 2x",
            "picto/InfoNoListingB2B_288.webp 3x"
        ],
        size: size
    });
};

const InfoNotificationMessagePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoNotificationMessage_96.webp",
        responsiveSrc: [
            "picto/InfoNotificationMessage_96.webp 1x",
            "picto/InfoNotificationMessage_192.webp 2x",
            "picto/InfoNotificationMessage_288.webp 3x"
        ],
        size: size
    });
};

const InfoProfilePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoProfile_96.webp",
        responsiveSrc: [
            "picto/InfoProfile_96.webp 1x",
            "picto/InfoProfile_192.webp 2x",
            "picto/InfoProfile_288.webp 3x"
        ],
        size: size
    });
};

const InfoQuitSavePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoQuitSave_96.webp",
        responsiveSrc: [
            "picto/InfoQuitSave_96.webp 1x",
            "picto/InfoQuitSave_192.webp 2x",
            "picto/InfoQuitSave_288.webp 3x"
        ],
        size: size
    });
};

const InfoQuittingPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoQuitting_96.webp",
        responsiveSrc: [
            "picto/InfoQuitting_96.webp 1x",
            "picto/InfoQuitting_192.webp 2x",
            "picto/InfoQuitting_288.webp 3x"
        ],
        size: size
    });
};

const InfoReceiveEmailPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoReceiveEmail_96.webp",
        responsiveSrc: [
            "picto/InfoReceiveEmail_96.webp 1x",
            "picto/InfoReceiveEmail_192.webp 2x",
            "picto/InfoReceiveEmail_288.webp 3x"
        ],
        size: size
    });
};

const InfoRentOutYourPropertyPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoRentOutYourProperty_96.webp",
        responsiveSrc: [
            "picto/InfoRentOutYourProperty_96.webp 1x",
            "picto/InfoRentOutYourProperty_192.webp 2x",
            "picto/InfoRentOutYourProperty_288.webp 3x"
        ],
        size: size
    });
};

const InfoResetConsumerPortalPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoResetConsumerPortal_96.webp",
        responsiveSrc: [
            "picto/InfoResetConsumerPortal_96.webp 1x",
            "picto/InfoResetConsumerPortal_192.webp 2x",
            "picto/InfoResetConsumerPortal_288.webp 3x"
        ],
        size: size
    });
};

const InfoResetPasswordEmailPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoResetPasswordEmail_96.webp",
        responsiveSrc: [
            "picto/InfoResetPasswordEmail_96.webp 1x",
            "picto/InfoResetPasswordEmail_192.webp 2x",
            "picto/InfoResetPasswordEmail_288.webp 3x"
        ],
        size: size
    });
};

const InfoResubscribeEmailPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoResubscribeEmail_96.webp",
        responsiveSrc: [
            "picto/InfoResubscribeEmail_96.webp 1x",
            "picto/InfoResubscribeEmail_192.webp 2x",
            "picto/InfoResubscribeEmail_288.webp 3x"
        ],
        size: size
    });
};

const InfoSearchPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoSearch_96.webp",
        responsiveSrc: [
            "picto/InfoSearch_96.webp 1x",
            "picto/InfoSearch_192.webp 2x",
            "picto/InfoSearch_288.webp 3x"
        ],
        size: size
    });
};

const InfoServiceNotPermitedPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoServiceNotPermited_96.webp",
        responsiveSrc: [
            "picto/InfoServiceNotPermited_96.webp 1x",
            "picto/InfoServiceNotPermited_192.webp 2x",
            "picto/InfoServiceNotPermited_288.webp 3x"
        ],
        size: size
    });
};

const InfoSignInAlertsPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoSignInAlerts_96.webp",
        responsiveSrc: [
            "picto/InfoSignInAlerts_96.webp 1x",
            "picto/InfoSignInAlerts_192.webp 2x",
            "picto/InfoSignInAlerts_288.webp 3x"
        ],
        size: size
    });
};

const InfoTransactionalEmailPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoTransactionalEmail_96.webp",
        responsiveSrc: [
            "picto/InfoTransactionalEmail_96.webp 1x",
            "picto/InfoTransactionalEmail_192.webp 2x",
            "picto/InfoTransactionalEmail_288.webp 3x"
        ],
        size: size
    });
};

const InfoVerificationCodePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoVerificationCode_96.webp",
        responsiveSrc: [
            "picto/InfoVerificationCode_96.webp 1x",
            "picto/InfoVerificationCode_192.webp 2x",
            "picto/InfoVerificationCode_288.webp 3x"
        ],
        size: size
    });
};

const InfoWaitingContactPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoWaitingContact_96.webp",
        responsiveSrc: [
            "picto/InfoWaitingContact_96.webp 1x",
            "picto/InfoWaitingContact_192.webp 2x",
            "picto/InfoWaitingContact_288.webp 3x"
        ],
        size: size
    });
};

const InfoWelcomeMessagePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/InfoWelcomeMessage_96.webp",
        responsiveSrc: [
            "picto/InfoWelcomeMessage_96.webp 1x",
            "picto/InfoWelcomeMessage_192.webp 2x",
            "picto/InfoWelcomeMessage_288.webp 3x"
        ],
        size: size
    });
};

const LoadingCalculationPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/LoadingCalculation_96.webp",
        responsiveSrc: [
            "picto/LoadingCalculation_96.webp 1x",
            "picto/LoadingCalculation_192.webp 2x",
            "picto/LoadingCalculation_288.webp 3x"
        ],
        size: size
    });
};

const LoadingCalculationProgressPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/LoadingCalculationProgress_96.webp",
        responsiveSrc: [
            "picto/LoadingCalculationProgress_96.webp 1x",
            "picto/LoadingCalculationProgress_192.webp 2x",
            "picto/LoadingCalculationProgress_288.webp 3x"
        ],
        size: size
    });
};

const LoadingFastPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/LoadingFast_96.webp",
        responsiveSrc: [
            "picto/LoadingFast_96.webp 1x",
            "picto/LoadingFast_192.webp 2x",
            "picto/LoadingFast_288.webp 3x"
        ],
        size: size
    });
};

const LoadingForcedUpdatePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/LoadingForcedUpdate_96.webp",
        responsiveSrc: [
            "picto/LoadingForcedUpdate_96.webp 1x",
            "picto/LoadingForcedUpdate_192.webp 2x",
            "picto/LoadingForcedUpdate_288.webp 3x"
        ],
        size: size
    });
};

const LoadingProfilePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/LoadingProfile_96.webp",
        responsiveSrc: [
            "picto/LoadingProfile_96.webp 1x",
            "picto/LoadingProfile_192.webp 2x",
            "picto/LoadingProfile_288.webp 3x"
        ],
        size: size
    });
};

const LoadingSlowPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/LoadingSlow_96.webp",
        responsiveSrc: [
            "picto/LoadingSlow_96.webp 1x",
            "picto/LoadingSlow_192.webp 2x",
            "picto/LoadingSlow_288.webp 3x"
        ],
        size: size
    });
};

const SelectionAddPicturesPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionAddPictures_96.webp",
        responsiveSrc: [
            "picto/SelectionAddPictures_96.webp 1x",
            "picto/SelectionAddPictures_192.webp 2x",
            "picto/SelectionAddPictures_288.webp 3x"
        ],
        size: size
    });
};

const SelectionBuildingDetailsPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionBuildingDetails_96.webp",
        responsiveSrc: [
            "picto/SelectionBuildingDetails_96.webp 1x",
            "picto/SelectionBuildingDetails_192.webp 2x",
            "picto/SelectionBuildingDetails_288.webp 3x"
        ],
        size: size
    });
};

const SelectionDescribeImagePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionDescribeImage_96.webp",
        responsiveSrc: [
            "picto/SelectionDescribeImage_96.webp 1x",
            "picto/SelectionDescribeImage_192.webp 2x",
            "picto/SelectionDescribeImage_288.webp 3x"
        ],
        size: size
    });
};

const SelectionExcatLocationPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionExcatLocation_96.webp",
        responsiveSrc: [
            "picto/SelectionExcatLocation_96.webp 1x",
            "picto/SelectionExcatLocation_192.webp 2x",
            "picto/SelectionExcatLocation_288.webp 3x"
        ],
        size: size
    });
};

const SelectionFloorLevelPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionFloorLevel_96.webp",
        responsiveSrc: [
            "picto/SelectionFloorLevel_96.webp 1x",
            "picto/SelectionFloorLevel_192.webp 2x",
            "picto/SelectionFloorLevel_288.webp 3x"
        ],
        size: size
    });
};

const SelectionForRentPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionForRent_96.webp",
        responsiveSrc: [
            "picto/SelectionForRent_96.webp 1x",
            "picto/SelectionForRent_192.webp 2x",
            "picto/SelectionForRent_288.webp 3x"
        ],
        size: size
    });
};

const SelectionForSellPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionForSell_96.webp",
        responsiveSrc: [
            "picto/SelectionForSell_96.webp 1x",
            "picto/SelectionForSell_192.webp 2x",
            "picto/SelectionForSell_288.webp 3x"
        ],
        size: size
    });
};

const SelectionIndividualPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionIndividual_96.webp",
        responsiveSrc: [
            "picto/SelectionIndividual_96.webp 1x",
            "picto/SelectionIndividual_192.webp 2x",
            "picto/SelectionIndividual_288.webp 3x"
        ],
        size: size
    });
};

const SelectionProfessionalPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionProfessional_96.webp",
        responsiveSrc: [
            "picto/SelectionProfessional_96.webp 1x",
            "picto/SelectionProfessional_192.webp 2x",
            "picto/SelectionProfessional_288.webp 3x"
        ],
        size: size
    });
};

const SelectionProperty1FacadePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionProperty1Facade_96.webp",
        responsiveSrc: [
            "picto/SelectionProperty1Facade_96.webp 1x",
            "picto/SelectionProperty1Facade_192.webp 2x",
            "picto/SelectionProperty1Facade_288.webp 3x"
        ],
        size: size
    });
};

const SelectionProperty2FacadePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionProperty2Facade_96.webp",
        responsiveSrc: [
            "picto/SelectionProperty2Facade_96.webp 1x",
            "picto/SelectionProperty2Facade_192.webp 2x",
            "picto/SelectionProperty2Facade_288.webp 3x"
        ],
        size: size
    });
};

const SelectionProperty3FacadePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionProperty3Facade_96.webp",
        responsiveSrc: [
            "picto/SelectionProperty3Facade_96.webp 1x",
            "picto/SelectionProperty3Facade_192.webp 2x",
            "picto/SelectionProperty3Facade_288.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyApartmentPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionPropertyApartment_96.webp",
        responsiveSrc: [
            "picto/SelectionPropertyApartment_96.webp 1x",
            "picto/SelectionPropertyApartment_192.webp 2x",
            "picto/SelectionPropertyApartment_288.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyClearViewPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionPropertyClearView_96.webp",
        responsiveSrc: [
            "picto/SelectionPropertyClearView_96.webp 1x",
            "picto/SelectionPropertyClearView_192.webp 2x",
            "picto/SelectionPropertyClearView_288.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyExceptionalViewPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionPropertyExceptionalView_96.webp",
        responsiveSrc: [
            "picto/SelectionPropertyExceptionalView_96.webp 1x",
            "picto/SelectionPropertyExceptionalView_192.webp 2x",
            "picto/SelectionPropertyExceptionalView_288.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyHousePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionPropertyHouse_96.webp",
        responsiveSrc: [
            "picto/SelectionPropertyHouse_96.webp 1x",
            "picto/SelectionPropertyHouse_192.webp 2x",
            "picto/SelectionPropertyHouse_288.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyObstructedViewPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionPropertyObstructedView_96.webp",
        responsiveSrc: [
            "picto/SelectionPropertyObstructedView_96.webp 1x",
            "picto/SelectionPropertyObstructedView_192.webp 2x",
            "picto/SelectionPropertyObstructedView_288.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyParkingGaragePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionPropertyParkingGarage_96.webp",
        responsiveSrc: [
            "picto/SelectionPropertyParkingGarage_96.webp 1x",
            "picto/SelectionPropertyParkingGarage_192.webp 2x",
            "picto/SelectionPropertyParkingGarage_288.webp 3x"
        ],
        size: size
    });
};

const SelectionShieldPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SelectionShield_96.webp",
        responsiveSrc: [
            "picto/SelectionShield_96.webp 1x",
            "picto/SelectionShield_192.webp 2x",
            "picto/SelectionShield_288.webp 3x"
        ],
        size: size
    });
};

const SuccessAdCreatedPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessAdCreated_96.webp",
        responsiveSrc: [
            "picto/SuccessAdCreated_96.webp 1x",
            "picto/SuccessAdCreated_192.webp 2x",
            "picto/SuccessAdCreated_288.webp 3x"
        ],
        size: size
    });
};

const SuccessBusinessServicesPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessBusinessServices_96.webp",
        responsiveSrc: [
            "picto/SuccessBusinessServices_96.webp 1x",
            "picto/SuccessBusinessServices_192.webp 2x",
            "picto/SuccessBusinessServices_288.webp 3x"
        ],
        size: size
    });
};

const SuccessCalculationFinishedPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessCalculationFinished_96.webp",
        responsiveSrc: [
            "picto/SuccessCalculationFinished_96.webp 1x",
            "picto/SuccessCalculationFinished_192.webp 2x",
            "picto/SuccessCalculationFinished_288.webp 3x"
        ],
        size: size
    });
};

const SuccessCancelRefundPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessCancelRefund_96.webp",
        responsiveSrc: [
            "picto/SuccessCancelRefund_96.webp 1x",
            "picto/SuccessCancelRefund_192.webp 2x",
            "picto/SuccessCancelRefund_288.webp 3x"
        ],
        size: size
    });
};

const SuccessConfirmPurchasePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessConfirmPurchase_96.webp",
        responsiveSrc: [
            "picto/SuccessConfirmPurchase_96.webp 1x",
            "picto/SuccessConfirmPurchase_192.webp 2x",
            "picto/SuccessConfirmPurchase_288.webp 3x"
        ],
        size: size
    });
};

const SuccessEmailConfirmationPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessEmailConfirmation_96.webp",
        responsiveSrc: [
            "picto/SuccessEmailConfirmation_96.webp 1x",
            "picto/SuccessEmailConfirmation_192.webp 2x",
            "picto/SuccessEmailConfirmation_288.webp 3x"
        ],
        size: size
    });
};

const SuccessEstimationResultCardPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessEstimationResultCard_96.webp",
        responsiveSrc: [
            "picto/SuccessEstimationResultCard_96.webp 1x",
            "picto/SuccessEstimationResultCard_192.webp 2x",
            "picto/SuccessEstimationResultCard_288.webp 3x"
        ],
        size: size
    });
};

const SuccessFindAClassifiedPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessFindAClassified_96.webp",
        responsiveSrc: [
            "picto/SuccessFindAClassified_96.webp 1x",
            "picto/SuccessFindAClassified_192.webp 2x",
            "picto/SuccessFindAClassified_288.webp 3x"
        ],
        size: size
    });
};

const SuccessFindALeadPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessFindALead_96.webp",
        responsiveSrc: [
            "picto/SuccessFindALead_96.webp 1x",
            "picto/SuccessFindALead_192.webp 2x",
            "picto/SuccessFindALead_288.webp 3x"
        ],
        size: size
    });
};

const SuccessFindATransactionPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessFindATransaction_96.webp",
        responsiveSrc: [
            "picto/SuccessFindATransaction_96.webp 1x",
            "picto/SuccessFindATransaction_192.webp 2x",
            "picto/SuccessFindATransaction_288.webp 3x"
        ],
        size: size
    });
};

const SuccessFindAUserPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessFindAUser_96.webp",
        responsiveSrc: [
            "picto/SuccessFindAUser_96.webp 1x",
            "picto/SuccessFindAUser_192.webp 2x",
            "picto/SuccessFindAUser_288.webp 3x"
        ],
        size: size
    });
};

const SuccessListingStandOutPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessListingStandOut_96.webp",
        responsiveSrc: [
            "picto/SuccessListingStandOut_96.webp 1x",
            "picto/SuccessListingStandOut_192.webp 2x",
            "picto/SuccessListingStandOut_288.webp 3x"
        ],
        size: size
    });
};

const SuccessMapDiscoveryPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessMapDiscovery_96.webp",
        responsiveSrc: [
            "picto/SuccessMapDiscovery_96.webp 1x",
            "picto/SuccessMapDiscovery_192.webp 2x",
            "picto/SuccessMapDiscovery_288.webp 3x"
        ],
        size: size
    });
};

const SuccessNotificationsValuePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessNotificationsValue_96.webp",
        responsiveSrc: [
            "picto/SuccessNotificationsValue_96.webp 1x",
            "picto/SuccessNotificationsValue_192.webp 2x",
            "picto/SuccessNotificationsValue_288.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyAlreadyEstimatedPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessPropertyAlreadyEstimated_96.webp",
        responsiveSrc: [
            "picto/SuccessPropertyAlreadyEstimated_96.webp 1x",
            "picto/SuccessPropertyAlreadyEstimated_192.webp 2x",
            "picto/SuccessPropertyAlreadyEstimated_288.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyBuildingPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessPropertyBuilding_96.webp",
        responsiveSrc: [
            "picto/SuccessPropertyBuilding_96.webp 1x",
            "picto/SuccessPropertyBuilding_192.webp 2x",
            "picto/SuccessPropertyBuilding_288.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyEstimationPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessPropertyEstimation_96.webp",
        responsiveSrc: [
            "picto/SuccessPropertyEstimation_96.webp 1x",
            "picto/SuccessPropertyEstimation_192.webp 2x",
            "picto/SuccessPropertyEstimation_288.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyFlatEstimationPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessPropertyFlatEstimation_96.webp",
        responsiveSrc: [
            "picto/SuccessPropertyFlatEstimation_96.webp 1x",
            "picto/SuccessPropertyFlatEstimation_192.webp 2x",
            "picto/SuccessPropertyFlatEstimation_288.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyHousePicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessPropertyHouse_96.webp",
        responsiveSrc: [
            "picto/SuccessPropertyHouse_96.webp 1x",
            "picto/SuccessPropertyHouse_192.webp 2x",
            "picto/SuccessPropertyHouse_288.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertySearchPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessPropertySearch_96.webp",
        responsiveSrc: [
            "picto/SuccessPropertySearch_96.webp 1x",
            "picto/SuccessPropertySearch_192.webp 2x",
            "picto/SuccessPropertySearch_288.webp 3x"
        ],
        size: size
    });
};

const SuccessThankYouRequestPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessThankYouRequest_96.webp",
        responsiveSrc: [
            "picto/SuccessThankYouRequest_96.webp 1x",
            "picto/SuccessThankYouRequest_192.webp 2x",
            "picto/SuccessThankYouRequest_288.webp 3x"
        ],
        size: size
    });
};

const SuccessWelcomeLeadToolPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessWelcomeLeadTool_96.webp",
        responsiveSrc: [
            "picto/SuccessWelcomeLeadTool_96.webp 1x",
            "picto/SuccessWelcomeLeadTool_192.webp 2x",
            "picto/SuccessWelcomeLeadTool_288.webp 3x"
        ],
        size: size
    });
};

const SuccessWelcomeSellerManagementPicto = ({ size = "32", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "picto/SuccessWelcomeSellerManagement_96.webp",
        responsiveSrc: [
            "picto/SuccessWelcomeSellerManagement_96.webp 1x",
            "picto/SuccessWelcomeSellerManagement_192.webp 2x",
            "picto/SuccessWelcomeSellerManagement_288.webp 3x"
        ],
        size: size
    });
};

const EmptyAgencyReviewsNoLoadingSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyAgencyReviewsNoLoading_144.webp",
        responsiveSrc: [
            "spot/EmptyAgencyReviewsNoLoading_144.webp 1x",
            "spot/EmptyAgencyReviewsNoLoading_288.webp 2x",
            "spot/EmptyAgencyReviewsNoLoading_432.webp 3x"
        ],
        size: size
    });
};

const EmptyEstimationSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyEstimation_144.webp",
        responsiveSrc: [
            "spot/EmptyEstimation_144.webp 1x",
            "spot/EmptyEstimation_288.webp 2x",
            "spot/EmptyEstimation_432.webp 3x"
        ],
        size: size
    });
};

const EmptyFindYourAddressSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyFindYourAddress_144.webp",
        responsiveSrc: [
            "spot/EmptyFindYourAddress_144.webp 1x",
            "spot/EmptyFindYourAddress_288.webp 2x",
            "spot/EmptyFindYourAddress_432.webp 3x"
        ],
        size: size
    });
};

const EmptyListingOfflineSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyListingOffline_144.webp",
        responsiveSrc: [
            "spot/EmptyListingOffline_144.webp 1x",
            "spot/EmptyListingOffline_288.webp 2x",
            "spot/EmptyListingOffline_432.webp 3x"
        ],
        size: size
    });
};

const EmptyListingRemovedSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyListingRemoved_144.webp",
        responsiveSrc: [
            "spot/EmptyListingRemoved_144.webp 1x",
            "spot/EmptyListingRemoved_288.webp 2x",
            "spot/EmptyListingRemoved_432.webp 3x"
        ],
        size: size
    });
};

const EmptyNoAlertSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyNoAlert_144.webp",
        responsiveSrc: [
            "spot/EmptyNoAlert_144.webp 1x",
            "spot/EmptyNoAlert_288.webp 2x",
            "spot/EmptyNoAlert_432.webp 3x"
        ],
        size: size
    });
};

const EmptyNoLeadsSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyNoLeads_144.webp",
        responsiveSrc: [
            "spot/EmptyNoLeads_144.webp 1x",
            "spot/EmptyNoLeads_288.webp 2x",
            "spot/EmptyNoLeads_432.webp 3x"
        ],
        size: size
    });
};

const EmptyNoListingYetSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyNoListingYet_144.webp",
        responsiveSrc: [
            "spot/EmptyNoListingYet_144.webp 1x",
            "spot/EmptyNoListingYet_288.webp 2x",
            "spot/EmptyNoListingYet_432.webp 3x"
        ],
        size: size
    });
};

const EmptyNoMessageYetSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyNoMessageYet_144.webp",
        responsiveSrc: [
            "spot/EmptyNoMessageYet_144.webp 1x",
            "spot/EmptyNoMessageYet_288.webp 2x",
            "spot/EmptyNoMessageYet_432.webp 3x"
        ],
        size: size
    });
};

const EmptyNoResultsFoundSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyNoResultsFound_144.webp",
        responsiveSrc: [
            "spot/EmptyNoResultsFound_144.webp 1x",
            "spot/EmptyNoResultsFound_288.webp 2x",
            "spot/EmptyNoResultsFound_432.webp 3x"
        ],
        size: size
    });
};

const EmptyNoReviewsAgencySpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyNoReviewsAgency_144.webp",
        responsiveSrc: [
            "spot/EmptyNoReviewsAgency_144.webp 1x",
            "spot/EmptyNoReviewsAgency_288.webp 2x",
            "spot/EmptyNoReviewsAgency_432.webp 3x"
        ],
        size: size
    });
};

const EmptyPropertyNoLoadingSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyPropertyNoLoading_144.webp",
        responsiveSrc: [
            "spot/EmptyPropertyNoLoading_144.webp 1x",
            "spot/EmptyPropertyNoLoading_288.webp 2x",
            "spot/EmptyPropertyNoLoading_432.webp 3x"
        ],
        size: size
    });
};

const EmptyPropertyNotFoundSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/EmptyPropertyNotFound_144.webp",
        responsiveSrc: [
            "spot/EmptyPropertyNotFound_144.webp 1x",
            "spot/EmptyPropertyNotFound_288.webp 2x",
            "spot/EmptyPropertyNotFound_432.webp 3x"
        ],
        size: size
    });
};

const Error404Spot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/Error404_144.webp",
        responsiveSrc: [
            "spot/Error404_144.webp 1x",
            "spot/Error404_288.webp 2x",
            "spot/Error404_432.webp 3x"
        ],
        size: size
    });
};

const Error500Spot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/Error500_144.webp",
        responsiveSrc: [
            "spot/Error500_144.webp 1x",
            "spot/Error500_288.webp 2x",
            "spot/Error500_432.webp 3x"
        ],
        size: size
    });
};

const ErrorCancelSubscriptionSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorCancelSubscription_144.webp",
        responsiveSrc: [
            "spot/ErrorCancelSubscription_144.webp 1x",
            "spot/ErrorCancelSubscription_288.webp 2x",
            "spot/ErrorCancelSubscription_432.webp 3x"
        ],
        size: size
    });
};

const ErrorDeviceNotSupportedSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorDeviceNotSupported_144.webp",
        responsiveSrc: [
            "spot/ErrorDeviceNotSupported_144.webp 1x",
            "spot/ErrorDeviceNotSupported_288.webp 2x",
            "spot/ErrorDeviceNotSupported_432.webp 3x"
        ],
        size: size
    });
};

const ErrorFavoritesUnavailableSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorFavoritesUnavailable_144.webp",
        responsiveSrc: [
            "spot/ErrorFavoritesUnavailable_144.webp 1x",
            "spot/ErrorFavoritesUnavailable_288.webp 2x",
            "spot/ErrorFavoritesUnavailable_432.webp 3x"
        ],
        size: size
    });
};

const ErrorListingOfflineSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorListingOffline_144.webp",
        responsiveSrc: [
            "spot/ErrorListingOffline_144.webp 1x",
            "spot/ErrorListingOffline_288.webp 2x",
            "spot/ErrorListingOffline_432.webp 3x"
        ],
        size: size
    });
};

const ErrorLoginViewSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorLoginView_144.webp",
        responsiveSrc: [
            "spot/ErrorLoginView_144.webp 1x",
            "spot/ErrorLoginView_288.webp 2x",
            "spot/ErrorLoginView_432.webp 3x"
        ],
        size: size
    });
};

const ErrorMapUnavailableSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorMapUnavailable_144.webp",
        responsiveSrc: [
            "spot/ErrorMapUnavailable_144.webp 1x",
            "spot/ErrorMapUnavailable_288.webp 2x",
            "spot/ErrorMapUnavailable_432.webp 3x"
        ],
        size: size
    });
};

const ErrorMisssingPageSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorMisssingPage_144.webp",
        responsiveSrc: [
            "spot/ErrorMisssingPage_144.webp 1x",
            "spot/ErrorMisssingPage_288.webp 2x",
            "spot/ErrorMisssingPage_432.webp 3x"
        ],
        size: size
    });
};

const ErrorNoInternetConnectionSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorNoInternetConnection_144.webp",
        responsiveSrc: [
            "spot/ErrorNoInternetConnection_144.webp 1x",
            "spot/ErrorNoInternetConnection_288.webp 2x",
            "spot/ErrorNoInternetConnection_432.webp 3x"
        ],
        size: size
    });
};

const ErrorNoServiceSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorNoService_144.webp",
        responsiveSrc: [
            "spot/ErrorNoService_144.webp 1x",
            "spot/ErrorNoService_288.webp 2x",
            "spot/ErrorNoService_432.webp 3x"
        ],
        size: size
    });
};

const ErrorPageUnavailableSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorPageUnavailable_144.webp",
        responsiveSrc: [
            "spot/ErrorPageUnavailable_144.webp 1x",
            "spot/ErrorPageUnavailable_288.webp 2x",
            "spot/ErrorPageUnavailable_432.webp 3x"
        ],
        size: size
    });
};

const ErrorPriceUnavailableSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorPriceUnavailable_144.webp",
        responsiveSrc: [
            "spot/ErrorPriceUnavailable_144.webp 1x",
            "spot/ErrorPriceUnavailable_288.webp 2x",
            "spot/ErrorPriceUnavailable_432.webp 3x"
        ],
        size: size
    });
};

const ErrorSearchNotAvailableSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorSearchNotAvailable_144.webp",
        responsiveSrc: [
            "spot/ErrorSearchNotAvailable_144.webp 1x",
            "spot/ErrorSearchNotAvailable_288.webp 2x",
            "spot/ErrorSearchNotAvailable_432.webp 3x"
        ],
        size: size
    });
};

const ErrorSomethingWentWrongSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorSomethingWentWrong_144.webp",
        responsiveSrc: [
            "spot/ErrorSomethingWentWrong_144.webp 1x",
            "spot/ErrorSomethingWentWrong_288.webp 2x",
            "spot/ErrorSomethingWentWrong_432.webp 3x"
        ],
        size: size
    });
};

const ErrorUnpaidInvoicesSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/ErrorUnpaidInvoices_144.webp",
        responsiveSrc: [
            "spot/ErrorUnpaidInvoices_144.webp 1x",
            "spot/ErrorUnpaidInvoices_288.webp 2x",
            "spot/ErrorUnpaidInvoices_432.webp 3x"
        ],
        size: size
    });
};

const InfoAddNoteRateSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoAddNoteRate_144.webp",
        responsiveSrc: [
            "spot/InfoAddNoteRate_144.webp 1x",
            "spot/InfoAddNoteRate_288.webp 2x",
            "spot/InfoAddNoteRate_432.webp 3x"
        ],
        size: size
    });
};

const InfoAgencyContactSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoAgencyContact_144.webp",
        responsiveSrc: [
            "spot/InfoAgencyContact_144.webp 1x",
            "spot/InfoAgencyContact_288.webp 2x",
            "spot/InfoAgencyContact_432.webp 3x"
        ],
        size: size
    });
};

const InfoAlertAddImageSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoAlertAddImage_144.webp",
        responsiveSrc: [
            "spot/InfoAlertAddImage_144.webp 1x",
            "spot/InfoAlertAddImage_288.webp 2x",
            "spot/InfoAlertAddImage_432.webp 3x"
        ],
        size: size
    });
};

const InfoAlmostThereSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoAlmostThere_144.webp",
        responsiveSrc: [
            "spot/InfoAlmostThere_144.webp 1x",
            "spot/InfoAlmostThere_288.webp 2x",
            "spot/InfoAlmostThere_432.webp 3x"
        ],
        size: size
    });
};

const InfoAudienceSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoAudience_144.webp",
        responsiveSrc: [
            "spot/InfoAudience_144.webp 1x",
            "spot/InfoAudience_288.webp 2x",
            "spot/InfoAudience_432.webp 3x"
        ],
        size: size
    });
};

const InfoCancelSubscriptionSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoCancelSubscription_144.webp",
        responsiveSrc: [
            "spot/InfoCancelSubscription_144.webp 1x",
            "spot/InfoCancelSubscription_288.webp 2x",
            "spot/InfoCancelSubscription_432.webp 3x"
        ],
        size: size
    });
};

const InfoConfirmEmailSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoConfirmEmail_144.webp",
        responsiveSrc: [
            "spot/InfoConfirmEmail_144.webp 1x",
            "spot/InfoConfirmEmail_288.webp 2x",
            "spot/InfoConfirmEmail_432.webp 3x"
        ],
        size: size
    });
};

const InfoCreateANoteSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoCreateANote_144.webp",
        responsiveSrc: [
            "spot/InfoCreateANote_144.webp 1x",
            "spot/InfoCreateANote_288.webp 2x",
            "spot/InfoCreateANote_432.webp 3x"
        ],
        size: size
    });
};

const InfoEmailSentSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoEmailSent_144.webp",
        responsiveSrc: [
            "spot/InfoEmailSent_144.webp 1x",
            "spot/InfoEmailSent_288.webp 2x",
            "spot/InfoEmailSent_432.webp 3x"
        ],
        size: size
    });
};

const InfoEnergyRenovationSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoEnergyRenovation_144.webp",
        responsiveSrc: [
            "spot/InfoEnergyRenovation_144.webp 1x",
            "spot/InfoEnergyRenovation_288.webp 2x",
            "spot/InfoEnergyRenovation_432.webp 3x"
        ],
        size: size
    });
};

const InfoExpandYourSearchSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoExpandYourSearch_144.webp",
        responsiveSrc: [
            "spot/InfoExpandYourSearch_144.webp 1x",
            "spot/InfoExpandYourSearch_288.webp 2x",
            "spot/InfoExpandYourSearch_432.webp 3x"
        ],
        size: size
    });
};

const InfoFeedbackSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoFeedback_144.webp",
        responsiveSrc: [
            "spot/InfoFeedback_144.webp 1x",
            "spot/InfoFeedback_288.webp 2x",
            "spot/InfoFeedback_432.webp 3x"
        ],
        size: size
    });
};

const InfoFeedbackTwoSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoFeedbackTwo_144.webp",
        responsiveSrc: [
            "spot/InfoFeedbackTwo_144.webp 1x",
            "spot/InfoFeedbackTwo_288.webp 2x",
            "spot/InfoFeedbackTwo_432.webp 3x"
        ],
        size: size
    });
};

const InfoFetchPropertySpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoFetchProperty_144.webp",
        responsiveSrc: [
            "spot/InfoFetchProperty_144.webp 1x",
            "spot/InfoFetchProperty_288.webp 2x",
            "spot/InfoFetchProperty_432.webp 3x"
        ],
        size: size
    });
};

const InfoFindYourAddressSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoFindYourAddress_144.webp",
        responsiveSrc: [
            "spot/InfoFindYourAddress_144.webp 1x",
            "spot/InfoFindYourAddress_288.webp 2x",
            "spot/InfoFindYourAddress_432.webp 3x"
        ],
        size: size
    });
};

const InfoFindYourAgencySpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoFindYourAgency_144.webp",
        responsiveSrc: [
            "spot/InfoFindYourAgency_144.webp 1x",
            "spot/InfoFindYourAgency_288.webp 2x",
            "spot/InfoFindYourAgency_432.webp 3x"
        ],
        size: size
    });
};

const InfoFirstAlertSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoFirstAlert_144.webp",
        responsiveSrc: [
            "spot/InfoFirstAlert_144.webp 1x",
            "spot/InfoFirstAlert_288.webp 2x",
            "spot/InfoFirstAlert_432.webp 3x"
        ],
        size: size
    });
};

const InfoFirstToKnowSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoFirstToKnow_144.webp",
        responsiveSrc: [
            "spot/InfoFirstToKnow_144.webp 1x",
            "spot/InfoFirstToKnow_288.webp 2x",
            "spot/InfoFirstToKnow_432.webp 3x"
        ],
        size: size
    });
};

const InfoHouseSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoHouse_144.webp",
        responsiveSrc: [
            "spot/InfoHouse_144.webp 1x",
            "spot/InfoHouse_288.webp 2x",
            "spot/InfoHouse_432.webp 3x"
        ],
        size: size
    });
};

const InfoMaintenanceSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoMaintenance_144.webp",
        responsiveSrc: [
            "spot/InfoMaintenance_144.webp 1x",
            "spot/InfoMaintenance_288.webp 2x",
            "spot/InfoMaintenance_432.webp 3x"
        ],
        size: size
    });
};

const InfoManagePropertiesSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoManageProperties_144.webp",
        responsiveSrc: [
            "spot/InfoManageProperties_144.webp 1x",
            "spot/InfoManageProperties_288.webp 2x",
            "spot/InfoManageProperties_432.webp 3x"
        ],
        size: size
    });
};

const InfoMoneySpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoMoney_144.webp",
        responsiveSrc: [
            "spot/InfoMoney_144.webp 1x",
            "spot/InfoMoney_288.webp 2x",
            "spot/InfoMoney_432.webp 3x"
        ],
        size: size
    });
};

const InfoNeedHelpSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoNeedHelp_144.webp",
        responsiveSrc: [
            "spot/InfoNeedHelp_144.webp 1x",
            "spot/InfoNeedHelp_288.webp 2x",
            "spot/InfoNeedHelp_432.webp 3x"
        ],
        size: size
    });
};

const InfoNoListingB2BSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoNoListingB2B_144.webp",
        responsiveSrc: [
            "spot/InfoNoListingB2B_144.webp 1x",
            "spot/InfoNoListingB2B_288.webp 2x",
            "spot/InfoNoListingB2B_432.webp 3x"
        ],
        size: size
    });
};

const InfoNotificationMessageSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoNotificationMessage_144.webp",
        responsiveSrc: [
            "spot/InfoNotificationMessage_144.webp 1x",
            "spot/InfoNotificationMessage_288.webp 2x",
            "spot/InfoNotificationMessage_432.webp 3x"
        ],
        size: size
    });
};

const InfoProfileSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoProfile_144.webp",
        responsiveSrc: [
            "spot/InfoProfile_144.webp 1x",
            "spot/InfoProfile_288.webp 2x",
            "spot/InfoProfile_432.webp 3x"
        ],
        size: size
    });
};

const InfoQuitSaveSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoQuitSave_144.webp",
        responsiveSrc: [
            "spot/InfoQuitSave_144.webp 1x",
            "spot/InfoQuitSave_288.webp 2x",
            "spot/InfoQuitSave_432.webp 3x"
        ],
        size: size
    });
};

const InfoQuittingSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoQuitting_144.webp",
        responsiveSrc: [
            "spot/InfoQuitting_144.webp 1x",
            "spot/InfoQuitting_288.webp 2x",
            "spot/InfoQuitting_432.webp 3x"
        ],
        size: size
    });
};

const InfoReceiveEmailSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoReceiveEmail_144.webp",
        responsiveSrc: [
            "spot/InfoReceiveEmail_144.webp 1x",
            "spot/InfoReceiveEmail_288.webp 2x",
            "spot/InfoReceiveEmail_432.webp 3x"
        ],
        size: size
    });
};

const InfoRentOutYourPropertySpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoRentOutYourProperty_144.webp",
        responsiveSrc: [
            "spot/InfoRentOutYourProperty_144.webp 1x",
            "spot/InfoRentOutYourProperty_288.webp 2x",
            "spot/InfoRentOutYourProperty_432.webp 3x"
        ],
        size: size
    });
};

const InfoResetConsumerPortalSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoResetConsumerPortal_144.webp",
        responsiveSrc: [
            "spot/InfoResetConsumerPortal_144.webp 1x",
            "spot/InfoResetConsumerPortal_288.webp 2x",
            "spot/InfoResetConsumerPortal_432.webp 3x"
        ],
        size: size
    });
};

const InfoResetPasswordEmailSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoResetPasswordEmail_144.webp",
        responsiveSrc: [
            "spot/InfoResetPasswordEmail_144.webp 1x",
            "spot/InfoResetPasswordEmail_288.webp 2x",
            "spot/InfoResetPasswordEmail_432.webp 3x"
        ],
        size: size
    });
};

const InfoResubscribeEmailSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoResubscribeEmail_144.webp",
        responsiveSrc: [
            "spot/InfoResubscribeEmail_144.webp 1x",
            "spot/InfoResubscribeEmail_288.webp 2x",
            "spot/InfoResubscribeEmail_432.webp 3x"
        ],
        size: size
    });
};

const InfoSearchSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoSearch_144.webp",
        responsiveSrc: [
            "spot/InfoSearch_144.webp 1x",
            "spot/InfoSearch_288.webp 2x",
            "spot/InfoSearch_432.webp 3x"
        ],
        size: size
    });
};

const InfoServiceNotPermitedSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoServiceNotPermited_144.webp",
        responsiveSrc: [
            "spot/InfoServiceNotPermited_144.webp 1x",
            "spot/InfoServiceNotPermited_288.webp 2x",
            "spot/InfoServiceNotPermited_432.webp 3x"
        ],
        size: size
    });
};

const InfoSignInAlertsSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoSignInAlerts_144.webp",
        responsiveSrc: [
            "spot/InfoSignInAlerts_144.webp 1x",
            "spot/InfoSignInAlerts_288.webp 2x",
            "spot/InfoSignInAlerts_432.webp 3x"
        ],
        size: size
    });
};

const InfoTransactionalEmailSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoTransactionalEmail_144.webp",
        responsiveSrc: [
            "spot/InfoTransactionalEmail_144.webp 1x",
            "spot/InfoTransactionalEmail_288.webp 2x",
            "spot/InfoTransactionalEmail_432.webp 3x"
        ],
        size: size
    });
};

const InfoVerificationCodeSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoVerificationCode_144.webp",
        responsiveSrc: [
            "spot/InfoVerificationCode_144.webp 1x",
            "spot/InfoVerificationCode_288.webp 2x",
            "spot/InfoVerificationCode_432.webp 3x"
        ],
        size: size
    });
};

const InfoWaitingContactSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoWaitingContact_144.webp",
        responsiveSrc: [
            "spot/InfoWaitingContact_144.webp 1x",
            "spot/InfoWaitingContact_288.webp 2x",
            "spot/InfoWaitingContact_432.webp 3x"
        ],
        size: size
    });
};

const InfoWelcomeMessageSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/InfoWelcomeMessage_144.webp",
        responsiveSrc: [
            "spot/InfoWelcomeMessage_144.webp 1x",
            "spot/InfoWelcomeMessage_288.webp 2x",
            "spot/InfoWelcomeMessage_432.webp 3x"
        ],
        size: size
    });
};

const LoadingCalculationSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/LoadingCalculation_144.webp",
        responsiveSrc: [
            "spot/LoadingCalculation_144.webp 1x",
            "spot/LoadingCalculation_288.webp 2x",
            "spot/LoadingCalculation_432.webp 3x"
        ],
        size: size
    });
};

const LoadingCalculationProgressSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/LoadingCalculationProgress_144.webp",
        responsiveSrc: [
            "spot/LoadingCalculationProgress_144.webp 1x",
            "spot/LoadingCalculationProgress_288.webp 2x",
            "spot/LoadingCalculationProgress_432.webp 3x"
        ],
        size: size
    });
};

const LoadingFastSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/LoadingFast_144.webp",
        responsiveSrc: [
            "spot/LoadingFast_144.webp 1x",
            "spot/LoadingFast_288.webp 2x",
            "spot/LoadingFast_432.webp 3x"
        ],
        size: size
    });
};

const LoadingForcedUpdateSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/LoadingForcedUpdate_144.webp",
        responsiveSrc: [
            "spot/LoadingForcedUpdate_144.webp 1x",
            "spot/LoadingForcedUpdate_288.webp 2x",
            "spot/LoadingForcedUpdate_432.webp 3x"
        ],
        size: size
    });
};

const LoadingProfileSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/LoadingProfile_144.webp",
        responsiveSrc: [
            "spot/LoadingProfile_144.webp 1x",
            "spot/LoadingProfile_288.webp 2x",
            "spot/LoadingProfile_432.webp 3x"
        ],
        size: size
    });
};

const LoadingSlowSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/LoadingSlow_144.webp",
        responsiveSrc: [
            "spot/LoadingSlow_144.webp 1x",
            "spot/LoadingSlow_288.webp 2x",
            "spot/LoadingSlow_432.webp 3x"
        ],
        size: size
    });
};

const SelectionAddPicturesSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionAddPictures_144.webp",
        responsiveSrc: [
            "spot/SelectionAddPictures_144.webp 1x",
            "spot/SelectionAddPictures_288.webp 2x",
            "spot/SelectionAddPictures_432.webp 3x"
        ],
        size: size
    });
};

const SelectionBuildingDetailsSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionBuildingDetails_144.webp",
        responsiveSrc: [
            "spot/SelectionBuildingDetails_144.webp 1x",
            "spot/SelectionBuildingDetails_288.webp 2x",
            "spot/SelectionBuildingDetails_432.webp 3x"
        ],
        size: size
    });
};

const SelectionDescribeImageSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionDescribeImage_144.webp",
        responsiveSrc: [
            "spot/SelectionDescribeImage_144.webp 1x",
            "spot/SelectionDescribeImage_288.webp 2x",
            "spot/SelectionDescribeImage_432.webp 3x"
        ],
        size: size
    });
};

const SelectionExcatLocationSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionExcatLocation_144.webp",
        responsiveSrc: [
            "spot/SelectionExcatLocation_144.webp 1x",
            "spot/SelectionExcatLocation_288.webp 2x",
            "spot/SelectionExcatLocation_432.webp 3x"
        ],
        size: size
    });
};

const SelectionFloorLevelSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionFloorLevel_144.webp",
        responsiveSrc: [
            "spot/SelectionFloorLevel_144.webp 1x",
            "spot/SelectionFloorLevel_288.webp 2x",
            "spot/SelectionFloorLevel_432.webp 3x"
        ],
        size: size
    });
};

const SelectionForRentSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionForRent_144.webp",
        responsiveSrc: [
            "spot/SelectionForRent_144.webp 1x",
            "spot/SelectionForRent_288.webp 2x",
            "spot/SelectionForRent_432.webp 3x"
        ],
        size: size
    });
};

const SelectionForSellSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionForSell_144.webp",
        responsiveSrc: [
            "spot/SelectionForSell_144.webp 1x",
            "spot/SelectionForSell_288.webp 2x",
            "spot/SelectionForSell_432.webp 3x"
        ],
        size: size
    });
};

const SelectionIndividualSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionIndividual_144.webp",
        responsiveSrc: [
            "spot/SelectionIndividual_144.webp 1x",
            "spot/SelectionIndividual_288.webp 2x",
            "spot/SelectionIndividual_432.webp 3x"
        ],
        size: size
    });
};

const SelectionProfessionalSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionProfessional_144.webp",
        responsiveSrc: [
            "spot/SelectionProfessional_144.webp 1x",
            "spot/SelectionProfessional_288.webp 2x",
            "spot/SelectionProfessional_432.webp 3x"
        ],
        size: size
    });
};

const SelectionProperty1FacadeSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionProperty1Facade_144.webp",
        responsiveSrc: [
            "spot/SelectionProperty1Facade_144.webp 1x",
            "spot/SelectionProperty1Facade_288.webp 2x",
            "spot/SelectionProperty1Facade_432.webp 3x"
        ],
        size: size
    });
};

const SelectionProperty2FacadeSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionProperty2Facade_144.webp",
        responsiveSrc: [
            "spot/SelectionProperty2Facade_144.webp 1x",
            "spot/SelectionProperty2Facade_288.webp 2x",
            "spot/SelectionProperty2Facade_432.webp 3x"
        ],
        size: size
    });
};

const SelectionProperty3FacadeSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionProperty3Facade_144.webp",
        responsiveSrc: [
            "spot/SelectionProperty3Facade_144.webp 1x",
            "spot/SelectionProperty3Facade_288.webp 2x",
            "spot/SelectionProperty3Facade_432.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyApartmentSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionPropertyApartment_144.webp",
        responsiveSrc: [
            "spot/SelectionPropertyApartment_144.webp 1x",
            "spot/SelectionPropertyApartment_288.webp 2x",
            "spot/SelectionPropertyApartment_432.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyClearViewSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionPropertyClearView_144.webp",
        responsiveSrc: [
            "spot/SelectionPropertyClearView_144.webp 1x",
            "spot/SelectionPropertyClearView_288.webp 2x",
            "spot/SelectionPropertyClearView_432.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyExceptionalViewSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionPropertyExceptionalView_144.webp",
        responsiveSrc: [
            "spot/SelectionPropertyExceptionalView_144.webp 1x",
            "spot/SelectionPropertyExceptionalView_288.webp 2x",
            "spot/SelectionPropertyExceptionalView_432.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyHouseSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionPropertyHouse_144.webp",
        responsiveSrc: [
            "spot/SelectionPropertyHouse_144.webp 1x",
            "spot/SelectionPropertyHouse_288.webp 2x",
            "spot/SelectionPropertyHouse_432.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyObstructedViewSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionPropertyObstructedView_144.webp",
        responsiveSrc: [
            "spot/SelectionPropertyObstructedView_144.webp 1x",
            "spot/SelectionPropertyObstructedView_288.webp 2x",
            "spot/SelectionPropertyObstructedView_432.webp 3x"
        ],
        size: size
    });
};

const SelectionPropertyParkingGarageSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionPropertyParkingGarage_144.webp",
        responsiveSrc: [
            "spot/SelectionPropertyParkingGarage_144.webp 1x",
            "spot/SelectionPropertyParkingGarage_288.webp 2x",
            "spot/SelectionPropertyParkingGarage_432.webp 3x"
        ],
        size: size
    });
};

const SelectionShieldSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SelectionShield_144.webp",
        responsiveSrc: [
            "spot/SelectionShield_144.webp 1x",
            "spot/SelectionShield_288.webp 2x",
            "spot/SelectionShield_432.webp 3x"
        ],
        size: size
    });
};

const SuccessAdCreatedSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessAdCreated_144.webp",
        responsiveSrc: [
            "spot/SuccessAdCreated_144.webp 1x",
            "spot/SuccessAdCreated_288.webp 2x",
            "spot/SuccessAdCreated_432.webp 3x"
        ],
        size: size
    });
};

const SuccessBusinessServicesSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessBusinessServices_144.webp",
        responsiveSrc: [
            "spot/SuccessBusinessServices_144.webp 1x",
            "spot/SuccessBusinessServices_288.webp 2x",
            "spot/SuccessBusinessServices_432.webp 3x"
        ],
        size: size
    });
};

const SuccessCalculationFinishedSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessCalculationFinished_144.webp",
        responsiveSrc: [
            "spot/SuccessCalculationFinished_144.webp 1x",
            "spot/SuccessCalculationFinished_288.webp 2x",
            "spot/SuccessCalculationFinished_432.webp 3x"
        ],
        size: size
    });
};

const SuccessCancelRefundSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessCancelRefund_144.webp",
        responsiveSrc: [
            "spot/SuccessCancelRefund_144.webp 1x",
            "spot/SuccessCancelRefund_288.webp 2x",
            "spot/SuccessCancelRefund_432.webp 3x"
        ],
        size: size
    });
};

const SuccessConfirmPurchaseSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessConfirmPurchase_144.webp",
        responsiveSrc: [
            "spot/SuccessConfirmPurchase_144.webp 1x",
            "spot/SuccessConfirmPurchase_288.webp 2x",
            "spot/SuccessConfirmPurchase_432.webp 3x"
        ],
        size: size
    });
};

const SuccessEmailConfirmationSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessEmailConfirmation_144.webp",
        responsiveSrc: [
            "spot/SuccessEmailConfirmation_144.webp 1x",
            "spot/SuccessEmailConfirmation_288.webp 2x",
            "spot/SuccessEmailConfirmation_432.webp 3x"
        ],
        size: size
    });
};

const SuccessEstimationResultCardSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessEstimationResultCard_144.webp",
        responsiveSrc: [
            "spot/SuccessEstimationResultCard_144.webp 1x",
            "spot/SuccessEstimationResultCard_288.webp 2x",
            "spot/SuccessEstimationResultCard_432.webp 3x"
        ],
        size: size
    });
};

const SuccessFindAClassifiedSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessFindAClassified_144.webp",
        responsiveSrc: [
            "spot/SuccessFindAClassified_144.webp 1x",
            "spot/SuccessFindAClassified_288.webp 2x",
            "spot/SuccessFindAClassified_432.webp 3x"
        ],
        size: size
    });
};

const SuccessFindALeadSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessFindALead_144.webp",
        responsiveSrc: [
            "spot/SuccessFindALead_144.webp 1x",
            "spot/SuccessFindALead_288.webp 2x",
            "spot/SuccessFindALead_432.webp 3x"
        ],
        size: size
    });
};

const SuccessFindATransactionSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessFindATransaction_144.webp",
        responsiveSrc: [
            "spot/SuccessFindATransaction_144.webp 1x",
            "spot/SuccessFindATransaction_288.webp 2x",
            "spot/SuccessFindATransaction_432.webp 3x"
        ],
        size: size
    });
};

const SuccessFindAUserSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessFindAUser_144.webp",
        responsiveSrc: [
            "spot/SuccessFindAUser_144.webp 1x",
            "spot/SuccessFindAUser_288.webp 2x",
            "spot/SuccessFindAUser_432.webp 3x"
        ],
        size: size
    });
};

const SuccessListingStandOutSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessListingStandOut_144.webp",
        responsiveSrc: [
            "spot/SuccessListingStandOut_144.webp 1x",
            "spot/SuccessListingStandOut_288.webp 2x",
            "spot/SuccessListingStandOut_432.webp 3x"
        ],
        size: size
    });
};

const SuccessMapDiscoverySpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessMapDiscovery_144.webp",
        responsiveSrc: [
            "spot/SuccessMapDiscovery_144.webp 1x",
            "spot/SuccessMapDiscovery_288.webp 2x",
            "spot/SuccessMapDiscovery_432.webp 3x"
        ],
        size: size
    });
};

const SuccessNotificationsValueSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessNotificationsValue_144.webp",
        responsiveSrc: [
            "spot/SuccessNotificationsValue_144.webp 1x",
            "spot/SuccessNotificationsValue_288.webp 2x",
            "spot/SuccessNotificationsValue_432.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyAlreadyEstimatedSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessPropertyAlreadyEstimated_144.webp",
        responsiveSrc: [
            "spot/SuccessPropertyAlreadyEstimated_144.webp 1x",
            "spot/SuccessPropertyAlreadyEstimated_288.webp 2x",
            "spot/SuccessPropertyAlreadyEstimated_432.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyBuildingSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessPropertyBuilding_144.webp",
        responsiveSrc: [
            "spot/SuccessPropertyBuilding_144.webp 1x",
            "spot/SuccessPropertyBuilding_288.webp 2x",
            "spot/SuccessPropertyBuilding_432.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyEstimationSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessPropertyEstimation_144.webp",
        responsiveSrc: [
            "spot/SuccessPropertyEstimation_144.webp 1x",
            "spot/SuccessPropertyEstimation_288.webp 2x",
            "spot/SuccessPropertyEstimation_432.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyFlatEstimationSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessPropertyFlatEstimation_144.webp",
        responsiveSrc: [
            "spot/SuccessPropertyFlatEstimation_144.webp 1x",
            "spot/SuccessPropertyFlatEstimation_288.webp 2x",
            "spot/SuccessPropertyFlatEstimation_432.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertyHouseSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessPropertyHouse_144.webp",
        responsiveSrc: [
            "spot/SuccessPropertyHouse_144.webp 1x",
            "spot/SuccessPropertyHouse_288.webp 2x",
            "spot/SuccessPropertyHouse_432.webp 3x"
        ],
        size: size
    });
};

const SuccessPropertySearchSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessPropertySearch_144.webp",
        responsiveSrc: [
            "spot/SuccessPropertySearch_144.webp 1x",
            "spot/SuccessPropertySearch_288.webp 2x",
            "spot/SuccessPropertySearch_432.webp 3x"
        ],
        size: size
    });
};

const SuccessThankYouRequestSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessThankYouRequest_144.webp",
        responsiveSrc: [
            "spot/SuccessThankYouRequest_144.webp 1x",
            "spot/SuccessThankYouRequest_288.webp 2x",
            "spot/SuccessThankYouRequest_432.webp 3x"
        ],
        size: size
    });
};

const SuccessWelcomeLeadToolSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessWelcomeLeadTool_144.webp",
        responsiveSrc: [
            "spot/SuccessWelcomeLeadTool_144.webp 1x",
            "spot/SuccessWelcomeLeadTool_288.webp 2x",
            "spot/SuccessWelcomeLeadTool_432.webp 3x"
        ],
        size: size
    });
};

const SuccessWelcomeSellerManagementSpot = ({ size = "72", ...rest })=>{
    return /*#__PURE__*/ jsx(Illustration, {
        ...rest,
        src: "spot/SuccessWelcomeSellerManagement_144.webp",
        responsiveSrc: [
            "spot/SuccessWelcomeSellerManagement_144.webp 1x",
            "spot/SuccessWelcomeSellerManagement_288.webp 2x",
            "spot/SuccessWelcomeSellerManagement_432.webp 3x"
        ],
        size: size
    });
};

export { EmptyAgencyReviewsNoLoadingHero, EmptyAgencyReviewsNoLoadingPicto, EmptyAgencyReviewsNoLoadingSpot, EmptyDefaultBackgroundBanner, EmptyEstimationHero, EmptyEstimationPicto, EmptyEstimationSpot, EmptyFindYourAddressHero, EmptyFindYourAddressPicto, EmptyFindYourAddressSpot, EmptyListingOfflineHero, EmptyListingOfflinePicto, EmptyListingOfflineSpot, EmptyListingRemovedHero, EmptyListingRemovedPicto, EmptyListingRemovedSpot, EmptyNoAlertHero, EmptyNoAlertPicto, EmptyNoAlertSpot, EmptyNoLeadsHero, EmptyNoLeadsPicto, EmptyNoLeadsSpot, EmptyNoListingYetHero, EmptyNoListingYetPicto, EmptyNoListingYetSpot, EmptyNoMessageYetHero, EmptyNoMessageYetPicto, EmptyNoMessageYetSpot, EmptyNoResultsFoundHero, EmptyNoResultsFoundPicto, EmptyNoResultsFoundSpot, EmptyNoReviewsAgencyHero, EmptyNoReviewsAgencyPicto, EmptyNoReviewsAgencySpot, EmptyPropertyNoLoadingHero, EmptyPropertyNoLoadingPicto, EmptyPropertyNoLoadingSpot, EmptyPropertyNotFoundHero, EmptyPropertyNotFoundPicto, EmptyPropertyNotFoundSpot, Error404Hero, Error404Picto, Error404Spot, Error500Hero, Error500Picto, Error500Spot, ErrorCancelSubscriptionHero, ErrorCancelSubscriptionPicto, ErrorCancelSubscriptionSpot, ErrorDeviceNotSupportedHero, ErrorDeviceNotSupportedPicto, ErrorDeviceNotSupportedSpot, ErrorFavoritesUnavailableBanner, ErrorFavoritesUnavailableHero, ErrorFavoritesUnavailablePicto, ErrorFavoritesUnavailableSpot, ErrorListingDeletedDisableBanner, ErrorListingOfflineHero, ErrorListingOfflinePicto, ErrorListingOfflineSpot, ErrorLoginViewHero, ErrorLoginViewPicto, ErrorLoginViewSpot, ErrorMapUnavailableHero, ErrorMapUnavailablePicto, ErrorMapUnavailableSpot, ErrorMisssingPageHero, ErrorMisssingPagePicto, ErrorMisssingPageSpot, ErrorNoInternetConnectionHero, ErrorNoInternetConnectionPicto, ErrorNoInternetConnectionSpot, ErrorNoServiceHero, ErrorNoServicePicto, ErrorNoServiceSpot, ErrorPageUnavailableHero, ErrorPageUnavailablePicto, ErrorPageUnavailableSpot, ErrorPriceUnavailableHero, ErrorPriceUnavailablePicto, ErrorPriceUnavailableSpot, ErrorSearchNotAvailableHero, ErrorSearchNotAvailablePicto, ErrorSearchNotAvailableSpot, ErrorSomethingWentWrongHero, ErrorSomethingWentWrongPicto, ErrorSomethingWentWrongSpot, ErrorUnpaidInvoicesHero, ErrorUnpaidInvoicesPicto, ErrorUnpaidInvoicesSpot, InfoAddNoteRateHero, InfoAddNoteRatePicto, InfoAddNoteRateSpot, InfoAgencyContactHero, InfoAgencyContactPicto, InfoAgencyContactSpot, InfoAlertAddImageHero, InfoAlertAddImagePicto, InfoAlertAddImageSpot, InfoAlmostThereHero, InfoAlmostTherePicto, InfoAlmostThereSpot, InfoAudienceHero, InfoAudiencePicto, InfoAudienceSpot, InfoCancelSubscriptionHero, InfoCancelSubscriptionPicto, InfoCancelSubscriptionSpot, InfoConfirmEmailHero, InfoConfirmEmailPicto, InfoConfirmEmailSpot, InfoCreateANoteHero, InfoCreateANotePicto, InfoCreateANoteSpot, InfoEmailSentHero, InfoEmailSentPicto, InfoEmailSentSpot, InfoEnergyRenovationHero, InfoEnergyRenovationPicto, InfoEnergyRenovationSpot, InfoExpandYourSearchHero, InfoExpandYourSearchPicto, InfoExpandYourSearchSpot, InfoFeedbackHero, InfoFeedbackPicto, InfoFeedbackSpot, InfoFeedbackTwoHero, InfoFeedbackTwoPicto, InfoFeedbackTwoSpot, InfoFetchPropertyHero, InfoFetchPropertyPicto, InfoFetchPropertySpot, InfoFindYourAddressHero, InfoFindYourAddressPicto, InfoFindYourAddressSpot, InfoFindYourAgencyHero, InfoFindYourAgencyPicto, InfoFindYourAgencySpot, InfoFirstAlertHero, InfoFirstAlertPicto, InfoFirstAlertSpot, InfoFirstToKnowHero, InfoFirstToKnowPicto, InfoFirstToKnowSpot, InfoHouseHero, InfoHousePicto, InfoHouseSpot, InfoMaintenanceHero, InfoMaintenancePicto, InfoMaintenanceSpot, InfoManagePropertiesHero, InfoManagePropertiesPicto, InfoManagePropertiesSpot, InfoMoneyHero, InfoMoneyPicto, InfoMoneySpot, InfoNeedHelpHero, InfoNeedHelpPicto, InfoNeedHelpSpot, InfoNoListingB2BHero, InfoNoListingB2BPicto, InfoNoListingB2BSpot, InfoNotificationMessageHero, InfoNotificationMessagePicto, InfoNotificationMessageSpot, InfoProfileHero, InfoProfilePicto, InfoProfileSpot, InfoQuitSaveHero, InfoQuitSavePicto, InfoQuitSaveSpot, InfoQuittingHero, InfoQuittingPicto, InfoQuittingSpot, InfoReceiveEmailHero, InfoReceiveEmailPicto, InfoReceiveEmailSpot, InfoRentOutYourPropertyHero, InfoRentOutYourPropertyPicto, InfoRentOutYourPropertySpot, InfoResetConsumerPortalHero, InfoResetConsumerPortalPicto, InfoResetConsumerPortalSpot, InfoResetPasswordEmailHero, InfoResetPasswordEmailPicto, InfoResetPasswordEmailSpot, InfoResubscribeEmailHero, InfoResubscribeEmailPicto, InfoResubscribeEmailSpot, InfoSearchHero, InfoSearchPicto, InfoSearchSpot, InfoServiceNotPermitedHero, InfoServiceNotPermitedPicto, InfoServiceNotPermitedSpot, InfoSignInAlertsHero, InfoSignInAlertsPicto, InfoSignInAlertsSpot, InfoTransactionalEmailHero, InfoTransactionalEmailPicto, InfoTransactionalEmailSpot, InfoVerificationCodeHero, InfoVerificationCodePicto, InfoVerificationCodeSpot, InfoWaitingContactHero, InfoWaitingContactPicto, InfoWaitingContactSpot, InfoWelcomeMessageHero, InfoWelcomeMessagePicto, InfoWelcomeMessageSpot, LoadingCalculationHero, LoadingCalculationPicto, LoadingCalculationProgressHero, LoadingCalculationProgressPicto, LoadingCalculationProgressSpot, LoadingCalculationSpot, LoadingFastHero, LoadingFastPicto, LoadingFastSpot, LoadingForcedUpdateHero, LoadingForcedUpdatePicto, LoadingForcedUpdateSpot, LoadingProfileHero, LoadingProfilePicto, LoadingProfileSpot, LoadingSlowHero, LoadingSlowPicto, LoadingSlowSpot, OnboardingAppBanner, OnboardingLandingPageBanner, PropertyCardApartmentBanner, PropertyCardHouseBanner, PropertyCardParkingBanner, SelectionAddPicturesHero, SelectionAddPicturesPicto, SelectionAddPicturesSpot, SelectionBuildingDetailsHero, SelectionBuildingDetailsPicto, SelectionBuildingDetailsSpot, SelectionDescribeImageHero, SelectionDescribeImagePicto, SelectionDescribeImageSpot, SelectionExcatLocationHero, SelectionExcatLocationPicto, SelectionExcatLocationSpot, SelectionFloorLevelHero, SelectionFloorLevelPicto, SelectionFloorLevelSpot, SelectionForRentHero, SelectionForRentPicto, SelectionForRentSpot, SelectionForSellHero, SelectionForSellPicto, SelectionForSellSpot, SelectionIndividualHero, SelectionIndividualPicto, SelectionIndividualSpot, SelectionProfessionalHero, SelectionProfessionalPicto, SelectionProfessionalSpot, SelectionProperty1FacadeHero, SelectionProperty1FacadePicto, SelectionProperty1FacadeSpot, SelectionProperty2FacadeHero, SelectionProperty2FacadePicto, SelectionProperty2FacadeSpot, SelectionProperty3FacadeHero, SelectionProperty3FacadePicto, SelectionProperty3FacadeSpot, SelectionPropertyApartmentHero, SelectionPropertyApartmentPicto, SelectionPropertyApartmentSpot, SelectionPropertyClearViewHero, SelectionPropertyClearViewPicto, SelectionPropertyClearViewSpot, SelectionPropertyExceptionalViewHero, SelectionPropertyExceptionalViewPicto, SelectionPropertyExceptionalViewSpot, SelectionPropertyHouseHero, SelectionPropertyHousePicto, SelectionPropertyHouseSpot, SelectionPropertyObstructedViewHero, SelectionPropertyObstructedViewPicto, SelectionPropertyObstructedViewSpot, SelectionPropertyParkingGarageHero, SelectionPropertyParkingGaragePicto, SelectionPropertyParkingGarageSpot, SelectionShieldHero, SelectionShieldPicto, SelectionShieldSpot, SuccessAdCreatedHero, SuccessAdCreatedPicto, SuccessAdCreatedSpot, SuccessBusinessServicesHero, SuccessBusinessServicesPicto, SuccessBusinessServicesSpot, SuccessCalculationFinishedHero, SuccessCalculationFinishedPicto, SuccessCalculationFinishedSpot, SuccessCancelRefundHero, SuccessCancelRefundPicto, SuccessCancelRefundSpot, SuccessConfirmPurchaseHero, SuccessConfirmPurchasePicto, SuccessConfirmPurchaseSpot, SuccessEmailConfirmationHero, SuccessEmailConfirmationPicto, SuccessEmailConfirmationSpot, SuccessEstimationResultCardHero, SuccessEstimationResultCardPicto, SuccessEstimationResultCardSpot, SuccessFindAClassifiedHero, SuccessFindAClassifiedPicto, SuccessFindAClassifiedSpot, SuccessFindALeadHero, SuccessFindALeadPicto, SuccessFindALeadSpot, SuccessFindATransactionHero, SuccessFindATransactionPicto, SuccessFindATransactionSpot, SuccessFindAUserHero, SuccessFindAUserPicto, SuccessFindAUserSpot, SuccessListingStandOutHero, SuccessListingStandOutPicto, SuccessListingStandOutSpot, SuccessMapDiscoveryHero, SuccessMapDiscoveryPicto, SuccessMapDiscoverySpot, SuccessNotificationsValueHero, SuccessNotificationsValuePicto, SuccessNotificationsValueSpot, SuccessPropertyAlreadyEstimatedHero, SuccessPropertyAlreadyEstimatedPicto, SuccessPropertyAlreadyEstimatedSpot, SuccessPropertyBuildingHero, SuccessPropertyBuildingPicto, SuccessPropertyBuildingSpot, SuccessPropertyEstimationHero, SuccessPropertyEstimationPicto, SuccessPropertyEstimationSpot, SuccessPropertyFlatEstimationHero, SuccessPropertyFlatEstimationPicto, SuccessPropertyFlatEstimationSpot, SuccessPropertyHouseHero, SuccessPropertyHousePicto, SuccessPropertyHouseSpot, SuccessPropertySearchHero, SuccessPropertySearchPicto, SuccessPropertySearchSpot, SuccessThankYouRequestHero, SuccessThankYouRequestPicto, SuccessThankYouRequestSpot, SuccessWelcomeLeadToolHero, SuccessWelcomeLeadToolPicto, SuccessWelcomeLeadToolSpot, SuccessWelcomeSellerManagementHero, SuccessWelcomeSellerManagementPicto, SuccessWelcomeSellerManagementSpot, TeaserMortgageHpBanner, TeaserMovingHpBanner, TeaserRenovationHpBanner };
//# sourceMappingURL=index.mjs.map
